<template>

  <div class="wrapper">

    <notifications> </notifications>
    <div class="main-panel main_background hidden-small">
      <top-navbar> </top-navbar>
      <my-content> </my-content>
      <content-footer> </content-footer>
    </div>

    <div class="main-panel main_background hidden-large">
      <el-row justify="center">
        <el-col :span="24"  class="hid-large" style="margin-top: 600px">
          <h1>OOPS!</h1>
        </el-col>
        <el-col :span="24" class="hid-large">
          <h3>Příliš nízké rozlišení displeje.</h3>
          <h3>Pro zobrazení aplikace je potřebné rozlišení alespoň FULL HD.</h3>
        </el-col>
      </el-row>
    </div>


    <el-dialog :visible.sync="modal_info" headerClasses="justify-content-center" :show-close="false">
              <div slot="header" class="modal-profile d-flex justify-content-center align-items-center">
                <i class="fas fa-times-circle"></i>
              </div>
                  <p>{{ modal_info_text }}</p>
                  <template slot="footer">
                    <el-button type="submit" link @click.native="m_modal_info(false)">Close</el-button>
                  </template>
    </el-dialog>

    <el-dialog :visible.sync="modal_operation" width="1500px" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed_modal_operation('form_operation')">
      <el-form ref="form_operation" :rules="rules_operation" size="mini" :model="operation">
        <el-row>
          <el-col :span="24">
            <el-card body-style="card-modal-prim">
              <el-row>
                <el-col :span="24" class="modal_1a" style="min-height: 180px;">
                  <el-row>
                    <el-col :span="10">
                      <span class="modal_title light_blue">Operace</span>
                      <span v-if="operation.id_operation < 1" class="modal_title green middle"><br><b>Nová</b></span>
                      <span v-show="modal_operation_ro" class="modal_title green middle"><br><b>Jen pro čtení</b></span>
                      <span v-if="operation.id_operation > 0 && !modal_operation_ro" class="modal_title green middle"><br><b>Editace</b></span>
                    </el-col>
                    <el-col :span="7" style="text-align: right; padding: 0 20px;">
                      <div>
                        <span class="modal_label dark_green">Lokalikace topo:</span>
                        <span class="modal_white small">  {{ patient_panel_a2 }}</span><br>
                        <span class="modal_label dark_green">Datum první diagnózy:</span>
                        <span class="modal_white small">  {{ patient_panel_a1 }}</span><br>
                        <span class="modal_label dark_green">Datum poslední kontroly:</span>
                        <span class="modal_white small">  {{ patient_panel_b }}</span>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <img src="img/user_03.png">
                    </el-col>
                    <el-col :span="5">
                      <span class="modal_white big">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
                      <div class="modal_white small">{{ patient.pat_birth_date }}</div>
                      <div class="modal_title middle_blue small">{{ patient.pat_city }}<span v-if="patient.pat_city.length > 0">,</span> {{ patient.pat_street }} {{ patient.pat_street_num }} </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row >
                <el-col style="min-height: 5px; background-color: #81cd81;">
                </el-col>
              </el-row>
              <el-row :class="{ modal_1b_ro: modal_operation_ro, modal_1b: !modal_operation_ro }">
                <el-col :span="24">
                  <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                      <div class="card-modal middle_blue">
                        <h3 class="modal_dark_blue title-1">Operace</h3>
                        <el-row :gutter="10" style="margin-bottom: 20px;">
                          <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
                            <div class="modal_title black"><span class="modal_label dark_green">*</span> Datum operace</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
                            <el-form-item prop="op_dat_oper">
                              <el-date-picker
                                v-model="op_dat_oper"
                                type="date"
                                format="dd. MM. yyyy"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                width="100%"
                                size="small"
                                :readonly="modal_operation_ro"
                                clearable
                                >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="modal_title black">Důvod operace</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_dark_blue title-4">Biopsie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <el-checkbox v-model="op_biop_ot" :disabled="modal_operation_ro">Otevřená</el-checkbox><br>
                                <el-checkbox v-model="op_biop_ster" :disabled="modal_operation_ro">Stereotaxe</el-checkbox><br>
                                <el-checkbox v-model="op_biop_free" :disabled="modal_operation_ro">Freehand</el-checkbox><br>
                                <el-checkbox v-model="op_biop_endo" :disabled="modal_operation_ro">Endoskop</el-checkbox><br>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_dark_blue title-4">Resekce</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <el-form-item class="">
                                  <el-select
                                    v-model="op_res"
                                    multiple
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_operation_ro"
                                    >
                                    <el-option
                                      v-for="item of op_resekce"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_label dark_blue">Rozsah resekce</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <el-form-item class="">
                                  <el-select
                                    v-model="op_roz_res"
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_operation_ro"
                                    >
                                    <el-option
                                      v-for="item of op_roz_resekce"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_label dark_blue">Přístup</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-form-item class="">
                                  <el-input
                                    type="textarea"
                                    :rows="7"
                                    v-model="op_pris"
                                    placeholder="Popis"
                                    :readonly="modal_operation_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_label dark_blue">Elektrofyziologie</div>
                              </el-col>
                              <el-col class="mt-10" :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <el-radio v-model="op_elektro" :label="1" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="op_elektro" :label="2" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_label dark_blue">MCS skore<br><small>zaškrtněte pokud ANO</small></div>
                              </el-col>
                              <el-col class="mt-10" :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <el-checkbox v-model="op_mcs_man_cev" :disabled="modal_operation_ro">Manipulace velkou cevou (1 bod)</el-checkbox><br>
                                <el-checkbox v-model="op_mcs_man_hlav" :disabled="modal_operation_ro">Manipulace hlavonervem (2 body)</el-checkbox><br>
                                <el-checkbox v-model="op_mcs_zad_jam" :disabled="modal_operation_ro">Zadni jama (1 bod)</el-checkbox><br>
                                <el-checkbox v-model="op_mcs_vet" :disabled="modal_operation_ro">Vetsi 4cm (1 bod)</el-checkbox><br>
                                <el-checkbox v-model="op_mcs_el" :disabled="modal_operation_ro">Elokventni zona (3 body)</el-checkbox>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <span class="modal_dark_blue title-4 mt-10"><i>Celkem</i></span>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
                                <p class="modal_dark_blue title-1 sum">{{ (+ op_mcs_man_cev) + (+ op_mcs_man_hlav)*2 + (+ op_mcs_zad_jam) + (+ op_mcs_vet) + (+ op_mcs_el)*3 }}</p>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bor">
                                <el-row>
                                  <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                    <div class="modal_dark_blue title-4">Hydrocefalus</div>
                                  </el-col>
                                  <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                                    <el-checkbox v-model="op_hyd_shu" :disabled="modal_operation_ro">Shunt</el-checkbox><br>
                                    <el-checkbox v-model="op_hyd_ev" :disabled="modal_operation_ro">E3v</el-checkbox>
                                    <el-checkbox v-model="op_hyd_kom" :disabled="modal_operation_ro">Kombinace</el-checkbox>
                                    <el-checkbox v-model="op_hyd_rev" :disabled="modal_operation_ro">Revize shuntu</el-checkbox>
                                    <el-checkbox v-model="op_hyd_jiny" @change="vymaz_op_hyd_jiny_text" :disabled="modal_operation_ro">Jiný</el-checkbox>
                                  </el-col>
                                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                    <el-form-item class="">
                                      <el-input
                                        :disabled="!(op_hyd_jiny)"
                                        type="textarea"
                                        :rows="7"
                                        v-model="op_hyd_jiny_text"
                                        placeholder="Popis hydrocefalus / jiný"
                                        :readonly="modal_operation_ro"
                                        >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                </el-row>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bor">
                                <el-row :gutter="10">
                                  <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                    <div class="modal_dark_blue title-4">Řešení <br>komplikací</div>
                                  </el-col>
                                  <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                                    <el-form-item class="">
                                      <el-cascader
                                        @change="vymaz_op_res_kompl"
                                        v-model="op_res_kompl"
                                        :options="l_op_cis_res_kompl"
                                        placeholder="Vyber variantu"
                                        :disabled="modal_operation_ro"
                                        :props="{ multiple: true, checkStrictly: false }"
                                        show-all-levels
                                        clearable
                                        >
                                      </el-cascader>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                    <el-form-item class="">
                                      <el-input
                                        :disabled="!( op_res_kompl.flat(1).includes('jiný') )"
                                        type="textarea"
                                        :rows="7"
                                        v-model="op_res_kom_jiny_text"
                                        placeholder="Popis hematom / jiný"
                                        :readonly="modal_operation_ro"
                                        >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                </el-row>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="bor">
                                <el-row>
                                  <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                    <div class="modal_dark_blue title-4">Jiný</div>
                                  </el-col>
                                  <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19">
                                    <el-form-item class="">
                                      <el-input
                                        type="textarea"
                                        :rows="5"
                                        v-model="op_jiny_text"
                                        placeholder="Popis"
                                        :readonly="modal_operation_ro"
                                        >
                                      </el-input>
                                    </el-form-item>
                                  </el-col>
                                </el-row>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col class="mt-10" :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
                            <div class="modal_title black">Endoskop</div>
                          </el-col>
                          <el-col class="mt-10" :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
                            <el-form-item class="">
                              <el-select
                                v-model="op_endo"
                                default-first-option
                                filterable
                                clearable
                                placeholder="Vyber variantu"
                                :disabled="modal_operation_ro"
                                >
                                <el-option
                                  v-for="item in op_endoskop"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="20">
                          <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3" class="mt-10">
                            <div class="modal_title black">Rychlá biopsie</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="mt-10">
                            <el-radio v-model="op_rych_bio" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                            <el-radio v-model="op_rych_bio" :label="false" @change="vymaz_op_rych_bio" :disabled="modal_operation_ro">NE</el-radio>
                            <el-checkbox :disabled="!op_rych_bio || modal_operation_ro" v-model="op_pred_dg">Předběžná dg</el-checkbox>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="24">
                  <div class="card-modal middle_blue">
                    <h3 class="modal_dark_blue title-1">Pooperační stav</h3>
                    <div class="modal_title black">Progrese deficitu</div>
                    <el-radio v-model="poo_st" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                    <el-radio v-model="poo_st" :label="false" :disabled="modal_operation_ro">NE</el-radio>
                    <el-row v-show="poo_st" :gutter="10">
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                        <div class="modal_title black mt-3">Pooperační stav</div>
                      </el-col>
                      <el-col :span="24">
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">Progrese parézy</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-radio v-model="poo_pro_par" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_pro_par" :label="false" @change="vymaz_poo_pro_par" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <el-checkbox :disabled="!poo_pro_par || modal_operation_ro" v-model="poo_pro_lhk" label="lhk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_par || modal_operation_ro" v-model="poo_pro_ldk" label="ldk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_par || modal_operation_ro" v-model="poo_pro_phk" label="phk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_par || modal_operation_ro" v-model="poo_pro_pdk" label="pdk"></el-checkbox>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <div class="modal_dark_blue title-4">Nejtěžší deficit</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <el-form-item class="">
                                  <el-select
                                    v-model="poo_nej_def_s"
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_operation_ro"
                                    >
                                    <el-option
                                      v-for="item of poo_mrs"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
                                <div class="modal_dark_blue title-4">Progrese fatiky</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-radio v-model="poo_pro_fa" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_pro_fa" :label="false" @change="vymaz_poo_pro_fa" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <el-checkbox :disabled="!poo_pro_fa || modal_operation_ro" v-model="poo_pro_fa_ex" label="Expresivní"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_fa || modal_operation_ro" v-model="poo_pro_fa_per" label="Percepční"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_fa || modal_operation_ro" v-model="poo_pro_fa_kom" label="Kombinovaná"></el-checkbox>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">Progrese hl. nervu</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-radio v-model="poo_pro_hl_ner" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_pro_hl_ner" :label="false" @change="vymaz_poo_pro_hl_ner" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4"></div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                                <el-form-item class="">
                                  <el-select
                                    :disabled="!poo_pro_hl_ner || modal_operation_ro"
                                    v-model="poo_pro_hl_ner_s"
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    >
                                    <el-option
                                      v-for="item of poo_pro_hl_nerv"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">Progrese sensitiv</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                <el-radio v-model="poo_pro_sen" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_pro_sen" :label="false" @change="vymaz_poo_pro_sen" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                <el-checkbox :disabled="!poo_pro_sen || modal_operation_ro" v-model="poo_pro_sen_lhk" label="lhk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_sen || modal_operation_ro" v-model="poo_pro_sen_ldk" label="ldk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_sen || modal_operation_ro" v-model="poo_pro_sen_phk" label="phk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_sen || modal_operation_ro" v-model="poo_pro_sen_pdk" label="pdk"></el-checkbox>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">Progrese ataxie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                <el-radio v-model="poo_pro_at" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_pro_at" :label="false" @change="vymaz_poo_pro_at" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                <el-checkbox :disabled="!poo_pro_at || modal_operation_ro" v-model="poo_pro_at_lhk" label="lhk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_at || modal_operation_ro" v-model="poo_pro_at_ldk" label="ldk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_at || modal_operation_ro" v-model="poo_pro_at_phk" label="phk"></el-checkbox><br>
                                <el-checkbox :disabled="!poo_pro_at || modal_operation_ro" v-model="poo_pro_at_pdk" label="pdk"></el-checkbox>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                      <el-col :span="24">
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">Progrese vědomí</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-radio v-model="poo_pro_ved" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_pro_ved" :label="false" @change="vymaz_poo_pro_ved" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4"></div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-form-item class="">
                                  <el-select
                                    :disabled="!poo_pro_ved || modal_operation_ro"
                                    default-first-option
                                    filterable
                                    clearable
                                    v-model="poo_pro_ved_s"
                                    placeholder="Vyber variantu">
                                    <el-option
                                      v-for="item of nth_gcs"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">30den mortalita</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-radio v-model="poo_mor" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_mor" :label="false" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                                <div class="modal_dark_blue title-4">Jiný</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19">
                                <el-form-item class="">
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    v-model="poo_jiny_text"
                                    placeholder="Popis"
                                    :readonly="modal_operation_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>

                      <el-col :span="24">
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <div class="modal_dark_blue title-4">Mozečkový mutismus</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-radio v-model="poo_moz_mu" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_moz_mu" :label="false" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <div class="modal_dark_blue title-4">Délka</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-input-number
                                  v-model="poo_delka"
                                  placeholder="Dny"
                                  :readonly="modal_operation_ro"
                                  size="small"
                                  :min="1"
                                  :max="100"
                                  :precision="0"
                                  >
                                </el-input-number>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="7" :lg="7" :xl="7" class="bor">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <div class="modal_dark_blue title-4">Reziduální postižení v 1R</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-radio v-model="poo_rez_pos" :label="true" :disabled="modal_operation_ro">ANO</el-radio>
                                <el-radio v-model="poo_rez_pos" :label="false" :disabled="modal_operation_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="!modal_operation_ro && operation.id_operation < 1" class="btn-green-big" @click.native="operation_new_save('form_operation')"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-if="!modal_operation_ro && operation.id_operation > 0" type="info" @click.native="operation_edit_save('form_operation')"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_operation_close('form_operation')"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>

      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_examination"  width="1500px" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed_modal_examination('form_examination')">
      <el-form ref="form_examination" :rules="rules_examination" size="mini" :model="examination">
        <el-row>
          <el-col :span="24">
            <el-card body-style="card-modal-prim">
              <el-row>
                <el-col :span="24" class="modal_1a" style="min-height: 180px;">
                  <el-row>
                    <el-col :span="10">
                      <span class="modal_title light_blue">Diagnóza/událost</span>
                      <span v-if="examination.id_examination < 1" class="modal_title green middle"><br><b>Nová</b></span>
                      <span v-show="modal_examination_ro" class="modal_title green middle"><br><b>Jen pro čtení</b></span>
                      <span v-if="examination.id_examination > 0 && !modal_examination_ro" class="modal_title green middle"><br><b>Editace</b></span>
                    </el-col>
                    <el-col :span="7" style="text-align: right; padding: 0 20px;">
                      <div v-if="examination.id_examination > 0">
                        <span class="modal_label dark_green">Lokalikace topo:</span>
                        <span class="modal_white small">  {{ patient_panel_a2 }}</span><br>
                        <span class="modal_label dark_green">Datum první diagnózy:</span>
                        <span class="modal_white small">  {{ patient_panel_a1 }}</span><br>
                        <span class="modal_label dark_green">Datum poslední kontroly:</span>
                        <span class="modal_white small">  {{ patient_panel_b }}</span>
                      </div>
                      <div v-else class="header_space">
                        <span class="modal_label dark_green">Lokalikace topo:</span><br>
                        <span class="modal_white small">  {{ patient_panel_a2 }}</span><br>
                        <span class="modal_label dark_green">Datum první diagnózy:</span>
                        <span class="modal_white small">  {{ patient_panel_a1 }}</span><br>
                        <span class="modal_label dark_green">Datum poslední kontroly:</span>
                        <span class="modal_white small">  {{ patient_panel_b }}</span>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <img src="img/user_03.png">
                    </el-col>
                    <el-col :span="5">
                      <span class="modal_white big">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
                      <div class="modal_white small">{{ patient.pat_birth_date }}</div>
                      <div class="modal_title middle_blue small">{{ patient.pat_city }}<span v-if="patient.pat_city.length > 0">,</span> {{ patient.pat_street }} {{ patient.pat_street_num }} </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row >
                <el-col style="min-height: 5px; background-color: #81cd81;">
                </el-col>
              </el-row>
              <el-row :class="{ modal_1b_ro: modal_examination_ro, modal_1b: !modal_examination_ro }">
                <el-col>
                  <el-row>
                    <el-col :span="16">
                      <div class="card-modal white">
                        <el-row>
                          <h5 class="modal_dark_blue title-1"></h5>
                          <el-col :span="5">
                            <div class="modal_label dark_grey"> Status</div>
                            <el-input type="number"
                                      placeholder=""
                                      v-model="examination_status"
                                      size="small"
                                      :min="0"
                                      :controls="false"
                                      :readonly="modal_examination_ro"
                                      >
                            </el-input>
                          </el-col>
                          <el-col :span="7" :offset="1">
                            <div class="modal_label dark_grey"><span class="modal_label dark_green">*</span> Začátek</div>
                            <el-form-item prop="started">
                              <el-date-picker
                                v-model="examination_started"
                                type="date"
                                format="dd. MM. yyyy"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                placeholder="Vyber datum"
                                width="100%"
                                size="small"
                                :readonly="modal_examination_ro"
                                clearable
                                >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                          <el-col :span="7" :offset="1">
                            <div class="modal_label dark_grey">Konec</div>
                            <el-date-picker
                              v-model="examination_finished"
                              type="date"
                              format="dd. MM. yyyy"
                              value-format="yyyy-MM-dd"
                              :picker-options="pickerOptions"
                              placeholder="Vyber datum"
                              width="100%"
                              size="small"
                              :readonly="modal_examination_ro"
                              clearable
                              >
                            </el-date-picker>
                          </el-col>
                          <el-col :span="12">
                            <div class="modal_label dark_grey">Poznámka - privátní</div>
                            <el-form-item class="">
                              <el-input
                                type="textarea"
                                :rows="4"
                                v-model="examination_description"
                                placeholder="Popis"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="11" :offset="1">
                            <div class="modal_label dark_grey">Poznámka - veřejná</div>
                            <el-form-item class="">
                              <el-input
                                type="textarea"
                                :rows="4"
                                v-model="examination_public_note"
                                placeholder="Popis"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :span="24">
                            <div><span class="modal_label dark_green">*</span> <i>povinné údaje</i></div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="card-modal middle_blue">
                        <el-row>
                          <el-col :span="24">
                            <el-row>
                              <el-col :span="9">
                                <span class="modal_dark_blue title-1">Lansky skore</span>
                              </el-col>
                              <el-col :span="15">
                                <el-form-item class="">
                                  <el-select
                                    v-model="lansky_skore_p"
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_examination_ro"
                                    >
                                    <el-option
                                      v-for="item of lansky_skore"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="24">
                            <el-row>
                              <el-col :span="9">
                                <span class="modal_dark_blue title-1">Ecog skore</span>
                              </el-col>
                              <el-col :span="15">
                                <el-form-item class="">
                                  <el-select
                                    v-model="ecog_skore_p"
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_examination_ro"
                                    >
                                    <el-option
                                      v-for="item of ecog_skore"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="24">
                            <el-row>
                              <el-col :span="9">
                                <span class="modal_dark_blue title-1">GCS</span>
                              </el-col>
                              <el-col :span="15">
                                <el-form-item class="">
                                  <el-select
                                    v-model="gcs"
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_examination_ro"
                                    >
                                    <el-option
                                      v-for="item of nth_gcs"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="14">
                      <div class="card-modal middle_blue">
                        <h5 class="modal_dark_blue title-1">Primární nádor</h5>
                        <el-row>
                          <el-col class="mt-10" :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <div class="modal_label dark_blue">Lokalizace strana</div>
                          </el-col>
                            <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                              <el-form-item class="bor">
                                <el-radio-group v-model="pn_lok_str" :disabled="modal_examination_ro">
                                  <el-radio :label="1" @click.native="click_exam_pn_lok_str">dx</el-radio>
                                  <el-radio :label="2" @click.native="click_exam_pn_lok_str">sin</el-radio>
                                  <el-radio :label="3" @click.native="click_exam_pn_lok_str">midline</el-radio>
                                </el-radio-group>
                              </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row style="margin-top: 10px;">
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <div class="modal_label dark_blue">Lokalizace topo<br> (primární)</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                            <el-form-item class="">
                              <el-select v-model="pn_lok_topo_prim" placeholder="Vyber variantu" @change="vymaz_pn_lok_topo_prim" style="min-width: 100%"
                                default-first-option
                                filterable
                                clearable
                                :disabled="modal_examination_ro"
                                >
                                <el-option
                                  v-for="one of l_exam_cis_pn_lok_topo_prim"
                                  :key="one.id_exam_cis_pn_lok_topo_prim"
                                  :label="one.nazev_pn_lok_topo_prim"
                                  :value="one.id_exam_cis_pn_lok_topo_prim"
                                  width="100%"
                                  size="small"
                                  >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10" style="margin-bottom: 10px;">
                            <el-form-item class="">
                              <el-input
                                :disabled="(pn_lok_topo_prim !== 20)"
                                type="textarea"
                                :rows="4"
                                v-model="pn_lok_topo_prim_jiny_text"
                                placeholder="Popis lokalizace topo primární / jiná"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <div class="modal_label dark_blue">Lokalizace topo<br> (šíření)</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                            <el-form-item class="">
                              <el-select
                                v-model="pn_lok_topo_sir"
                                multiple
                                default-first-option
                                filterable
                                clearable
                                placeholder="Vyber varianty"
                                @change="vymaz_pn_lok_topo_sir"
                                :disabled="modal_examination_ro"
                                >
                                <el-option
                                  v-for="one of l_exam_cis_pn_lok_topo_prim"
                                  :key="one.id_exam_cis_pn_lok_topo_prim"
                                  :label="one.nazev_pn_lok_topo_prim"
                                  :value="one.id_exam_cis_pn_lok_topo_prim"
                                  width="100%"
                                  size="small"
                                  >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                            <el-form-item class="">
                              <el-input
                                :disabled="!(pn_lok_topo_sir.includes(20))"
                                type="textarea"
                                :rows="4"
                                v-model="pn_lok_topo_sir_jiny_text"
                                placeholder="Popis lokalizace topo šíření / jiná"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row class="mt-10">
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <div class="modal_label dark_blue">Elokventní zóna</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                            <el-form-item>
                              <el-col>
                                <el-radio v-model="pn_el_zona" :label="1" :disabled="modal_examination_ro">ANO</el-radio>
                                <el-radio v-model="pn_el_zona" :label="2" :disabled="modal_examination_ro">NE</el-radio>
                              </el-col>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="6">
                            <div class="modal_label dark_blue">Velikost ap (mm)</div>
                          </el-col>
                          <el-col :span="6">
                            <el-input-number
                            v-model="pn_vel_ap"
                            size="mini"
                            controls-position="right"
                            @change="handleChange"
                            :min="0"
                            :max="10000"
                            :disabled="modal_examination_ro"
                            >
                            </el-input-number>
                          </el-col>
                          <el-col :span="6">
                            <div class="modal_label dark_blue">Velikost later (mm)</div>
                          </el-col>
                          <el-col :span="6">
                            <el-input-number
                            v-model="pn_vel_lat"
                            size="mini"
                            controls-position="right"
                            @change="handleChange"
                            :min="0"
                            :max="10000"
                            :disabled="modal_examination_ro"
                            >
                            </el-input-number>
                          </el-col>
                        </el-row>
                        <el-row :gutter="10">
                          <el-col :span="6">
                            <div class="modal_label dark_blue">Velikost krakau (mm)</div>
                          </el-col>
                          <el-col :span="6">
                           <el-input-number
                           v-model="pn_vel_kra"
                           size="mini"
                           controls-position="right"
                           @change="handleChange"
                           :min="0"
                           :max="10000"
                           :disabled="modal_examination_ro"
                           >
                            </el-input-number>
                          </el-col>
                          <el-col :span="6">
                            <div class="modal_label dark_blue">Volumometrie (mm<sup>3</sup>)</div>
                          </el-col>
                          <el-col :span="6">
                           <el-input-number
                           v-model="pn_vol"
                           size="mini"
                           controls-position="right"
                           @change="handleChange"
                           :min="0"
                           :max="10000"
                           :disabled="modal_examination_ro"
                           >
                            </el-input-number>
                          </el-col>
                        </el-row>
                        <el-row class="mt-10">
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <div class="modal_label dark_blue">Neurovaskulární str</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <el-form-item class="">
                              <el-col>
                                <template>
                                  <el-radio v-model="pn_neuro_str_v" :label="true" :disabled="modal_examination_ro">ANO</el-radio>
                                  <el-radio v-model="pn_neuro_str_v" :label="false" @change="vymaz_pn_neuro_str_v" :disabled="modal_examination_ro">NE</el-radio>
                                </template>
                              </el-col>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <el-form-item class="">
                              <el-col>
                                <el-select
                                  :disabled="!pn_neuro_str_v || modal_examination_ro"
                                  v-model="pn_neuro_str_m"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  @change="vymaz_pn_neuro_str_m"
                                  >
                                  <el-option
                                    v-for="item of pn_neuro_str_pos"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                    >
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <p></p>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <el-form-item class="">
                              <el-input
                                :disabled="!pn_neuro_str_v || (pn_neuro_str_v && !pn_neuro_str_m.includes('jiný'))"
                                type="textarea"
                                :rows="3"
                                v-model="pn_neuro_str_jiny_text"
                                placeholder="Popis neurovaskulární str / jiný"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <div class="card-modal middle_blue">
                        <h5 class="modal_dark_blue title-1">Další nádor</h5>
                        <el-row style="padding-bottom: 5px;">
                          <el-col :span="8">
                            <div class="modal_label dark_blue">Progrese rezidua</div>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item class="">
                              <el-input
                                type="textarea"
                                :rows="3"
                                v-model="dn_prog_rez_text"
                                placeholder="Popis charakteristiky"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row style="padding-bottom: 5px;">
                          <el-col :span="8">
                            <div class="modal_label dark_blue">Lokální recidiva</div>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item class="">
                              <el-input
                                type="textarea"
                                :rows="3"
                                v-model="dn_lok_rec_text"
                                placeholder="Popis charakteristiky"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row style="padding-bottom: 5px;">
                          <el-col :span="8">
                            <div class="modal_label dark_blue">Distant metastaza</div>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item class="">
                              <el-input
                                type="textarea"
                                :rows="3"
                                v-model="dn_dis_met_text"
                                placeholder="Popis charakteristiky"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="8">
                            <div class="modal_label dark_blue">Duplicita</div>
                          </el-col>
                          <el-col :span="16">
                            <el-form-item class="">
                              <el-input
                                type="textarea"
                                :rows="3"
                                v-model="dn_dupl_text"
                                placeholder="Popis charakteristiky"
                                :readonly="modal_examination_ro"
                                >
                              </el-input>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="14">
                      <el-row>
                        <el-col :span="24">
                          <div class="card-modal middle_blue">
                            <h5 class="modal_dark_blue title-1">Observace nádoru</h5>
                            <el-row :gutter="5">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Primární observace</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                                <el-radio v-model="on_prim" :label="1" :disabled="modal_examination_ro">ANO</el-radio>
                                <el-radio v-model="on_prim" :label="2" :disabled="modal_examination_ro">NE</el-radio>
                              </el-col>
                            </el-row>
                            <el-row :gutter="5" style="margin-top: 10px;">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Observace nádoru</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item class="">
                                  <el-select
                                    v-model="ob_nad"
                                    multiple
                                    default-first-option
                                    filterable
                                    clearable
                                    placeholder="Vyber variantu"
                                    :disabled="modal_examination_ro"
                                    >
                                    <el-option
                                      v-for="item of ob_nad_vycet"
                                      :key="item"
                                      :label="item"
                                      :value="item"
                                      >
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row :gutter="5">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Ukončena pro</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item>
                                  <el-checkbox v-model="on_d_uk_pro_prog_gr" class="modal_title grey small" :disabled="modal_examination_ro">Progrese na zobrazení</el-checkbox>
                                  <el-checkbox v-model="on_d_uk_pro_prog_sym" class="modal_title grey small" :disabled="modal_examination_ro">Progrese symptomu</el-checkbox>
                                  <el-checkbox v-model="on_d_uk_pro_pra" class="modal_title grey small" :disabled="modal_examination_ro">Přání pacienta</el-checkbox><br>
                                  <el-checkbox v-model="on_d_uk_pro_jiny" class="modal_title grey small" @change="vymaz_on_d_uk_pro_jiny_text" :disabled="modal_examination_ro">Jiný</el-checkbox>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item class="">
                                  <el-input
                                    :disabled="!(on_d_uk_pro_jiny)"
                                    type="textarea"
                                    :rows="3"
                                    v-model="on_d_uk_pro_jiny_text"
                                    placeholder="Popis ukončena pro / jiný"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row :gutter="5">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Datum ukončení</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item class="">
                                  <el-date-picker
                                    v-model="on_d_uk"
                                    type="date"
                                    format="dd. MM. yyyy"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                    placeholder="Vyber datum"
                                    width="100%"
                                    :readonly="modal_examination_ro"
                                    clearable
                                    >
                                  </el-date-picker>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="10">
                      <el-row>
                        <el-col :span="24">
                          <div class="card-modal middle_blue">
                            <h5 class="modal_dark_blue title-1">Diagnóza</h5>
                            <el-row :gutter="5" style="margin-top: 10px;">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Diagnóza</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item class="">
                                  <el-select
                                    v-model="id_diagnoza"
                                    placeholder="Vyberte diagnózu"
                                    filterable
                                    clearable
                                    :disabled="modal_examination_ro"
                                    >
                                    <el-option-group
                                      v-for="dg in l_diags"
                                      :key="dg.dg_name"
                                      :label="dg.dg_name">
                                      <el-option
                                        v-for="item in dg.dg_list"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-option-group>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>

                            <el-row :gutter="5" style="margin-top: 10px;">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Skupina nádorů</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item class="">
                                  <el-select
                                    v-model="id_nador"
                                    placeholder="Vyberte nádor"
                                    filterable
                                    clearable
                                    :disabled="modal_examination_ro"
                                    >
                                    <el-option
                                      v-for="item in l_exam_cis_sk_nadoru"
                                      :key="item.id_nador"
                                      :label="item.nador_nazev"
                                      :value="item.id_nador">
                                    </el-option>
                                  </el-select>
                                </el-form-item>
                              </el-col>
                            </el-row>


                            <el-row :gutter="5">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Datum diagnózy</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="9" :lg="9" :xl="9">
                                <el-form-item class="">
                                  <el-date-picker
                                    v-model="diagnoza_dat"
                                    type="date"
                                    format="dd. MM. yyyy"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                    placeholder="Vyber datum"
                                    :readonly="modal_examination_ro"
                                    width="100%"
                                    clearable
                                    >
                                  </el-date-picker>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="14">
                      <div class="card-modal middle_blue">
                        <h5 class="modal_dark_blue title-1">Vstupní staging</h5>
                        <el-row :gutter="10" style="margin-bottom: 20px;">
                          <el-col :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
                            <div class="modal_label dark_blue">Datum</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="2" :lg="2" :xl="2">
                            <el-form-item class="">
                              <el-date-picker
                                type="date"
                                v-model="vstup_st"
                                format="dd. MM. yyyy"
                                value-format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                                placeholder="Vyber datum"
                                width="100%"
                                :disabled="modal_examination_ro"
                                clearable
                                >
                              </el-date-picker>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row class="bor">
                          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="modal_dark_blue title-2">Metastázy</div>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                            <el-radio v-model="vstup_st_met" :disabled="modal_examination_ro" :label="true">ANO</el-radio>
                            <el-radio v-model="vstup_st_met" :disabled="modal_examination_ro" :label="false" @change="vymaz_vstup_st_met_rad">NE</el-radio>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-radio
                                  :disabled="modal_examination_ro || !vstup_st_met" v-model="vstup_st_met_rad" label="intra" @change="vymaz_vstup_st_met_1" @click.native="click_exam_vstup_st_met_rad">Intrakraniální
                                </el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item class="">
                                  <el-input
                                    :disabled="vstup_st_met_rad !== 'intra'"
                                    type="textarea"
                                    :rows="2"
                                    v-model="vstup_st_met_intra_text"
                                    placeholder="Popis"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row  class="mt-10">
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-radio
                                  :disabled="modal_examination_ro || !vstup_st_met"
                                  v-model="vstup_st_met_rad"
                                  label="kan"
                                  @change="vymaz_vstup_st_met_2"
                                  @click.native="click_exam_vstup_st_met_rad">Páteřní kanál
                                </el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item>
                                  <el-input
                                    :disabled="vstup_st_met_rad !== 'kan'"
                                    type="textarea"
                                    :rows="2"
                                    v-model="vstup_st_met_kan_text"
                                    placeholder="Popis"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row class="mt-10">
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-radio
                                  :disabled="modal_examination_ro || !vstup_st_met"
                                  v-model="vstup_st_met_rad"
                                  label="intrakan"
                                  @change="vymaz_vstup_st_met_3"
                                  @click.native="click_exam_vstup_st_met_rad">Intrakraniální + páteřní kanál
                                </el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item class="">
                                  <el-input
                                    :disabled="vstup_st_met_rad !== 'intrakan'"
                                    type="textarea"
                                    :rows="2"
                                    v-model="vstup_st_met_intr_kan_text"
                                    placeholder="Popis"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_dark_blue title-2">Cytologie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                                <el-form-item class="">
                                  <el-date-picker
                                    v-model="vstup_st_cyt"
                                    type="date"
                                    format="dd. MM. yyyy"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions"
                                    placeholder="Vyber datum"
                                    width="100%"
                                    :disabled="modal_examination_ro"
                                    clearable
                                    >
                                  </el-date-picker>
                                </el-form-item>
                              </el-col>
                                <el-col>
                                  <el-row>
                                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                      <el-radio-group v-model="vstup_st_cyt_pn" :disabled="modal_examination_ro">
                                        <el-radio :label="true" @click.native="click_exam_vstup_st_cyt_pn">Pozitivní</el-radio>
                                        <el-radio :label="false" @change="vymaz_vstup_st_cyt_p_text" @click.native="click_exam_vstup_st_cyt_pn">Negativní</el-radio>
                                      </el-radio-group>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                                      <el-form-item class="">
                                        <el-input
                                          :disabled="!vstup_st_cyt_pn"
                                          type="textarea"
                                          :rows="2"
                                          v-model="vstup_st_cyt_p_text"
                                          placeholder="Pozitivní cytologie"
                                          :readonly="modal_examination_ro"
                                          >
                                        </el-input>
                                      </el-form-item>
                                    </el-col>
                                  </el-row>
                                </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="10" :lg="10" :xl="10">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                                <div class="modal_dark_blue title-2">Staging Change</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                                <el-radio-group v-model="vstup_st_cha" :disabled="modal_examination_ro">
                                  <el-radio label="1" @click.native="click_exam_vstup_st_cha">M0</el-radio>
                                  <el-radio label="2" @click.native="click_exam_vstup_st_cha">M1</el-radio>
                                  <el-radio label="3" @click.native="click_exam_vstup_st_cha">M2</el-radio>
                                  <el-radio label="4" @click.native="click_exam_vstup_st_cha">M3</el-radio>
                                </el-radio-group>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="10">
                      <el-row>
                        <el-col :span="24">
                          <div class="card-modal middle_blue">
                            <h5 class="modal_dark_blue title-1">Výsledky molekulární genetiky</h5>
                            <el-row :gutter="5" class="mb-10">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Nalezena SNV</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <el-radio v-model="mol_ge_snv" :label="1" :disabled="modal_examination_ro" >ANO</el-radio>
                                <el-radio v-model="mol_ge_snv" :label="2" :disabled="modal_examination_ro" @change="vymaz_mol_ge_snv_text">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item class="">
                                  <el-input
                                    :disabled="(mol_ge_snv === 2) || (mol_ge_snv == null)"
                                    type="textarea"
                                    :rows="3"
                                    v-model="mol_ge_snv_text"
                                    placeholder="Popis ukončena pro / jiný"
                                    :readonly="modal_examination_ro"

                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row :gutter="5" class="mb-10">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Nalezena fúze</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <el-radio v-model="mol_ge_fuze" :label="1" :disabled="modal_examination_ro">ANO</el-radio>
                                <el-radio v-model="mol_ge_fuze" :label="2" :disabled="modal_examination_ro" @change="vymaz_mol_ge_fuze_text">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item class="">
                                  <el-input
                                    :disabled="(mol_ge_fuze === 2) || (mol_ge_fuze == null)"
                                    type="textarea"
                                    :rows="3"
                                    v-model="mol_ge_fuze_text"
                                    placeholder="Popis ukončena pro / jiný"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row :gutter="5" class="mb-10">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Nalezena CNV</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <el-radio v-model="mol_ge_cnv" :label="1" :disabled="modal_examination_ro">ANO</el-radio>
                                <el-radio v-model="mol_ge_cnv" :label="2" :disabled="modal_examination_ro" @change="vymaz_mol_ge_cnv_text">NE</el-radio>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <el-form-item class="">
                                  <el-input
                                    :disabled="(mol_ge_cnv === 2) || (mol_ge_cnv == null)"
                                    type="textarea"
                                    :rows="3"
                                    v-model="mol_ge_cnv_text"
                                    placeholder="Popis ukončena pro / jiný"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row :gutter="5">
                              <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                                <div class="modal_label dark_blue">Methylační třída</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
                                <el-form-item class="">
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    v-model="mol_ge_methyl_text"
                                    placeholder="Popis ukončena pro / jiný"
                                    :readonly="modal_examination_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="!modal_examination_ro && examination.id_examination < 1" class="btn-green-big" link @click.native="examination_new_save('form_examination')"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-if="!modal_examination_ro && examination.id_examination > 0" type="info" link @click.native="examination_edit_save('form_examination')"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_examination_close('form_examination')"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>

      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_checkup" width="1500px" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed_modal_checkup('form_checkup')">
      <el-form ref="form_checkup" :rules="rules_checkup" size="mini" :model="checkup">

        <el-row>
          <el-col :span="24">
            <el-card body-style="card-modal-prim">
              <el-row>
                <el-col :span="24" class="modal_1a" style="min-height: 180px;">
                  <el-row>
                    <el-col :span="10">
                      <span class="modal_title light_blue">Ambulantní kontrola</span>
                      <span v-if="checkup.id_checkup < 1" class="modal_title green middle"><br><b>Nová</b></span>
                      <span v-show="modal_checkup_ro" class="modal_title green middle"><br><b>Jen pro čtení</b></span>
                      <span v-if="checkup.id_checkup > 0 && !modal_checkup_ro" class="modal_title green middle"><br><b>Editace</b></span>
                    </el-col>
                    <el-col :span="7" style="text-align: right; padding: 0 20px;">
                      <div>
                        <span class="modal_label dark_green">Lokalikace topo:</span>
                        <span class="modal_white small">  {{ patient_panel_a2 }}</span><br>
                        <span class="modal_label dark_green">Datum první diagnózy:</span>
                        <span class="modal_white small">  {{ patient_panel_a1 }}</span><br>
                        <span class="modal_label dark_green">Datum poslední kontroly:</span>
                        <span class="modal_white small">  {{ patient_panel_b }}</span>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <img src="img/user_03.png">
                    </el-col>
                    <el-col :span="5">
                      <span class="modal_white big">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
                      <div class="modal_white small">{{ patient.pat_birth_date }}</div>
                      <div class="modal_title middle_blue small">{{ patient.pat_city }}<span v-if="patient.pat_city.length > 0">,</span> {{ patient.pat_street }} {{ patient.pat_street_num }} </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="min-height: 5px; background-color: #81cd81;">
                </el-col>
              </el-row>
              <el-row :class="{ modal_1b_ro: modal_checkup_ro, modal_1b: !modal_checkup_ro }">
                <el-col :span="16">
                  <div class="card-modal middle_blue">
                    <el-row>
                      <el-col :span="8">
                        <div class="modal_label dark_blue"><span class="modal_label dark_green">*</span> Oddělení</div>
                        <el-form-item prop="id_dept">
                          <el-select
                            v-model="checkup_id_dept"
                            default-first-option
                            filterable
                            clearable
                            placeholder="Vyber variantu"
                            :disabled="modal_checkup_ro"
                            @change="change_checkup_id_dept"
                            >
                            <el-option
                              v-for="item of l_check_cis_dept"
                              :key="item.id_dept"
                              :label="item.dept_name"
                              :value="item.id_dept">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7" :offset="1">
                        <div class="modal_label dark_blue"><span class="modal_label dark_green">*</span> Lékař</div>
                        <el-form-item prop="doctor_id_user">
                          <el-select
                            v-model="checkup_doctor_id_user"
                            default-first-option
                            filterable
                            clearable
                            placeholder="Vyber variantu"
                            :disabled="modal_checkup_ro"
                            >
                            <el-option
                              v-for="item in g_l_doctors(checkup_id_dept)"
                              :key="item.id_user"
                              :label="item.user_name"
                              :value="item.id_user">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="7" :offset="1">
                        <div class="modal_label dark_blue">Datum kontroly</div>
                        <el-form-item class="">
                          <el-date-picker
                            type="date"
                            placeholder=""
                            v-model="checkup_dt_when"
                            format="dd. MM. yyyy"
                            value-format="yyyy-MM-dd"
                            :picker-options="pickerOptions"
                            width="100%"
                            size="small"
                            :readonly="modal_checkup_ro"
                            clearable
                            >
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <div class="modal_label dark_blue">Poznámky veřejné</div>
                        <el-form-item class="">
                          <el-input
                            type="textarea"
                            :rows="4"
                            v-model="checkup_public_note"
                            placeholder="Popis"
                            :readonly="modal_checkup_ro"
                            >
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="1">
                        <div class="modal_label dark_blue">Poznámky privátní</div>
                          <el-form-item class="">
                            <el-input
                              type="textarea"
                              :rows="4"
                              v-model="checkup_privat_note"
                              placeholder="Popis"
                              :readonly="modal_checkup_ro"
                              >
                            </el-input>
                          </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-card>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="!modal_checkup_ro && checkup.id_checkup < 1" class="btn-green-big" @click.native="checkup_new_save('form_checkup')"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-if="!modal_checkup_ro && checkup.id_checkup > 0" type="info" link @click.native="checkup_edit_save('form_checkup')"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_checkup_close('form_checkup')"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>

      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="modal_medication" width="1600px" headerClasses="justify-content-center" :show-close="true" center :close-on-click-modal="false" :close-on-press-escape="false" @closed="closed_modal_medication('form_medication')">
      <el-form ref="form_medication" size="mini" :model="medication">
        <el-row>
          <el-card body-style="card-modal-prim_pom" class="card-modal-prim_pom">
            <el-col :span="24">
              <el-row>
                <el-col :span="24" class="modal_1a_pom" style="min-height: 180px;">
                  <el-row>
                    <el-col :span="10">
                      <span class="modal_title light_blue">Léčba</span>
                      <span v-if="medication.id_medication < 1" class="modal_title green middle"><br><b>Nová</b></span>
                      <span v-show="modal_medication_ro" class="modal_title green middle"><br><b>Jen pro čtení</b></span>
                      <span v-if="medication.id_medication > 0 && !modal_medication_ro" class="modal_title green middle"><br><b>Editace</b></span>
                    </el-col>
                    <el-col :span="7" style="text-align: right; padding: 0 20px;">
                      <div>
                        <span class="modal_label dark_green">Lokalikace topo:</span>
                        <span class="modal_white small">  {{ patient_panel_a2 }}</span><br>
                        <span class="modal_label dark_green">Datum první diagnózy:</span>
                        <span class="modal_white small">  {{ patient_panel_a1 }}</span><br>
                        <span class="modal_label dark_green">Datum poslední kontroly:</span>
                        <span class="modal_white small">  {{ patient_panel_b }}</span>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <img src="img/user_03.png" style="margin: 0 20px; float: center;">
                    </el-col>
                    <el-col :span="4">
                      <span class="modal_white big">{{ patient.pat_surname }} {{ patient.pat_name }}</span>
                      <div class="modal_white small">{{ patient.pat_birth_date }}</div>
                      <div class="modal_title middle_blue small">{{ patient.pat_city }}<span v-if="patient.pat_city.length > 0">,</span> {{ patient.pat_street }} {{ patient.pat_street_num }} </div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
              <el-row>
                <el-col style="min-height: 5px; background-color: #81cd81;">
                </el-col>
              </el-row>
              <el-row :class="{ modal_1b_ro: modal_medication_ro, modal_1b: !modal_medication_ro }">
                <el-col :span="24">
                  <el-row >
                    <el-col :span="12">
                      <div class="card-modal middle_blue">
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="modal_dark_blue title-1">Číselník protokolu</div>
                            <el-form-item>
                              <el-select
                                v-model="medication_id_med_cis_protokol"
                                default-first-option
                                filterable
                                clearable
                                placeholder="Vyber variantu"
                                :disabled="modal_medication_ro"
                                >
                                <el-option
                                  v-for="item in med_cis_protokol"
                                  :key="item.id_med_cis_protokol"
                                  :label="item.nazev_protokol"
                                  :value="item.id_med_cis_protokol"
                                  >
                                </el-option>
                              </el-select>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <div class="modal_dark_blue title-1">Klinická studie</div>
                            <el-form-item>
                              <el-radio v-model="medication_klin_st" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                              <el-radio v-model="medication_klin_st" :label="false" :disabled="modal_medication_ro">NE</el-radio>
                            </el-form-item>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row :gutter="15">
                    <el-col :span="12">
                      <div class="card-modal middle_blue">
                        <h3 class="modal_dark_blue title-1">Chemoterapie intenzivní</h3>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item>
                              <el-radio v-model="medication_chem_int" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                              <el-radio v-model="medication_chem_int" :label="false" @change="vymaz_medication_chem_int" :disabled="modal_medication_ro">NE</el-radio>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="13" :lg="13" :xl="13">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                                <div class="modal_label dark_blue">Začátek</div>
                                <el-date-picker
                                  :disabled="!medication_chem_int"
                                  v-model="medication_chem_int_z"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  :readonly="modal_medication_ro"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                                <div class="modal_label dark_blue">Konec</div>
                                <el-date-picker
                                  :disabled="!medication_chem_int"
                                  v-model="medication_chem_int_k"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  :readonly="modal_medication_ro"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
                                <div class="modal_label dark_blue">Cytostatika</div>
                                <el-select
                                  v-model="medication_chem_int_cyt"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  :disabled="modal_medication_ro || !medication_chem_int"
                                  >
                                  <el-option
                                    v-for="item in l_med_cis_chem_int_cyt"
                                    :key="item.cytostatika_nazev"
                                    :label="item.cytostatika_nazev"
                                    :value="item.cytostatika_nazev">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Komplikace <br>chemoterapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_chem_int_kom" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_chem_int_kom" :label="false" @change="vymaz_medication_chem_int_kom" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Druh</div>
                                <el-form-item class="">
                                  <el-cascader
                                    :disabled="!medication_chem_int_kom || modal_medication_ro"
                                    v-model="medication_chem_int_kom_dr"
                                    :options="l_med_cis_kompl_dr"
                                    placeholder="Vyber variantu"
                                    clearable
                                    show-all-levels
                                    :props="{multiple: true}"
                                    >
                                  </el-cascader>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Redukce cytostatik</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_chem_int_re_cyt" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_chem_int_re_cyt" :label="false" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Intrathekální terapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_chem_int_inthe_ter" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_chem_int_inthe_ter" :label="false" @change="vymaz_medication_chem_inthe_ter" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Cytostatika</div>
                                <el-select
                                  :disabled="!medication_chem_int_inthe_ter || modal_medication_ro"
                                  v-model="medication_chem_int_inthe_ter_cyt"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  >
                                  <el-option
                                    v-for="item in l_med_cis_chem_int_inthe_inver_cyt"
                                    :key="item.cytostatika_nazev"
                                    :label="item.cytostatika_nazev"
                                    :value="item.cytostatika_nazev">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Intraventrikulární terapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_chem_int_inver_ter" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_chem_int_inver_ter" :label="false" @change="vymaz_medication_chem_int_inver_ter" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Cytostatika</div>
                                <el-select
                                  :disabled="!medication_chem_int_inver_ter || modal_medication_ro"
                                  v-model="medication_chem_int_inver_ter_cyt"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  >
                                  <el-option
                                    v-for="item in l_med_cis_chem_int_inthe_inver_cyt"
                                    :key="item.cytostatika_nazev"
                                    :label="item.cytostatika_nazev"
                                    :value="item.cytostatika_nazev">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="card-modal middle_blue">
                        <h3 class="modal_dark_blue title-1">Udržovací/metronomická chemoterapie</h3>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-form-item>
                              <el-radio v-model="medication_udr_chem" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                              <el-radio v-model="medication_udr_chem" :label="false" @change="vymaz_medication_udr_chem" :disabled="modal_medication_ro">NE</el-radio>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Začátek</div>
                                <el-date-picker
                                  :disabled="!medication_udr_chem"
                                  v-model="medication_udr_chem_z"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  :readonly="modal_medication_ro"
                                  width="100%"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Konec</div>
                                <el-date-picker
                                  :disabled="!medication_udr_chem"
                                  v-model="medication_udr_chem_k"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  :readonly="modal_medication_ro"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                                <div class="modal_label dark_blue">Popis udržovací<br>chemoterapie</div>
                                <el-form-item>
                                  <el-input
                                    :disabled="!medication_udr_chem"
                                    type="textarea"
                                    :rows="2"
                                    placeholder="Popis"
                                    v-model="medication_udr_chem_text"
                                    :readonly="modal_medication_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Komplikace <br>udržovací chemoterapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_udr_chem_kom" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_udr_chem_kom" :label="false" @change="vymaz_medication_udr_chem_kom" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Druh</div>
                                <el-form-item class="">
                                  <el-cascader
                                    :disabled="!medication_udr_chem_kom || modal_medication_ro"
                                    v-model="medication_udr_chem_kom_dr"
                                    :options="l_med_cis_kompl_dr"
                                    placeholder="Vyber variantu"
                                    clearable
                                    show-all-levels
                                    :props="{multiple: true}"
                                    >
                                  </el-cascader>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Redukce cytostatik</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                                <el-form-item>
                                  <el-radio v-model="medication_udr_chem_re_cyt" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_udr_chem_re_cyt" :label="false" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Intrathekální terapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_udr_chem_inthe_ter" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_udr_chem_inthe_ter" :label="false" @change="vymaz_medication_udr_chem_inthe_ter" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Cytostatika</div>
                                <el-select
                                  :disabled="!medication_udr_chem_inthe_ter || modal_medication_ro"
                                  v-model="medication_udr_chem_inthe_ter_cyt"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  >
                                  <el-option
                                    v-for="item in l_med_cis_udr_chem_inthe_inver_cyt"
                                    :key="item.cytostatika_nazev"
                                    :label="item.cytostatika_nazev"
                                    :value="item.cytostatika_nazev">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Intraventrikulární terapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_udr_chem_inver_ter" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_udr_chem_inver_ter" :label="false" @change="vymaz_medication_udr_chem_inver_ter" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Cytostatika</div>
                                <el-select
                                  :disabled="!medication_udr_chem_inver_ter || modal_medication_ro"
                                  v-model="medication_udr_chem_inver_ter_cyt"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  >
                                  <el-option
                                    v-for="item in l_med_cis_udr_chem_inthe_inver_cyt"
                                    :key="item.cytostatika_nazev"
                                    :label="item.cytostatika_nazev"
                                    :value="item.cytostatika_nazev">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="7">
                      <div class="card-modal middle_blue">
                        <h3 class="modal_dark_blue title-1">Biologická/cílená terapie</h3>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="15" :lg="15" :xl="15">
                            <el-form-item>
                              <el-radio v-model="medication_bio_ter" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                              <el-radio v-model="medication_bio_ter" :label="false" :disabled="modal_medication_ro" @change="vymaz_medication_bio_ter">NE</el-radio>
                            </el-form-item>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Začátek</div>
                                <el-date-picker
                                  :disabled="!medication_bio_ter || modal_medication_ro"
                                  v-model="medication_bio_ter_z"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Konec</div>
                                <el-date-picker
                                  :disabled="!medication_bio_ter || modal_medication_ro"
                                  v-model="medication_bio_ter_k"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
                              <div class="modal_label dark_blue">Jméno léku</div>
                                <el-select
                                  :disabled="!medication_bio_ter || modal_medication_ro"
                                  v-model="medication_bio_ter_lek"
                                  multiple
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber lék"
                                  >
                                  <el-option
                                    v-for="item in l_med_cis_bio_ter_lek"
                                    :key="item.lek_nazev"
                                    :label="item.lek_nazev"
                                    :value="item.lek_nazev">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Komplikace</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_bio_ter_kom" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_bio_ter_kom" :label="false" @change="vymaz_medication_bio_ter_kom" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                              <div class="modal_label dark_blue">Druh</div>
                                <el-form-item class="">
                                  <el-cascader
                                    :disabled="!medication_bio_ter_kom || modal_medication_ro"
                                    v-model="medication_bio_ter_kom_dr"
                                    :options="l_med_cis_kompl_dr"
                                    placeholder="Vyber variantu"
                                    clearable
                                    show-all-levels
                                    :props="{multiple: true}"
                                    >
                                  </el-cascader>
                                </el-form-item>
                              </el-col>
                             </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Redukce</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_bio_ter_re" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_bio_ter_re" :label="false" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="11">
                      <div class="card-modal middle_blue">
                        <h3 class="modal_dark_blue title-1">Radioterapie</h3>
                        <el-row>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                            <el-form-item>
                              <el-radio v-model="medication_rad" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                              <el-radio v-model="medication_rad" :label="false" @change="vymaz_medication_rad" :disabled="modal_medication_ro">NE</el-radio>
                            </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                            <div class="modal_label dark_blue">Typ radioterapie</div>
                            <el-select
                              :disabled="!medication_rad || modal_medication_ro"
                              v-model="medication_rad_typ"
                              default-first-option
                              filterable
                              clearable
                              placeholder="Vyber variantu"
                              >
                              <el-option
                                v-for="item of med_rad_typ_v"
                                :key="item"
                                :label="item"
                                :value="item">
                              </el-option>
                            </el-select>
                          </el-col>
                          <el-col :span="12">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Datum zahájení</div>
                                <el-date-picker
                                  v-model="medication_rad_z"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  :readonly="modal_medication_ro"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col v-if="medication_id_operation > 0" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Datum operace</div>
                                <el-date-picker
                                  v-model="medication_rad_op"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Datum operace"
                                  width="100%"
                                  readonly
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col v-if="medication_id_operation > 0" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Počet dní od operace</div>
                              </el-col>
                              <el-col  v-if="medication_id_operation > 0" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <div class="sum" style="min-height: 28px"><b>{{ medication_rad_op_od }}</b></div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Datum ukončení</div>
                                <el-date-picker
                                  v-model="medication_rad_k"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  :readonly="modal_medication_ro"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Rozsah radioterapie</div>
                                <el-select
                                  v-model="medication_rad_roz"
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  :disabled="modal_medication_ro"
                                  >
                                  <el-option
                                    v-for="item of med_rad_roz_v"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                  </el-option>
                                </el-select>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Dávka radioterapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Kraniospinální (Gy)</div>
                                <el-input-number
                                  v-model="medication_rad_dav_kra"
                                  :min="0"
                                  :max="100"
                                  :readonly="modal_medication_ro"
                                  :precision="2"
                                  >
                                </el-input-number>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Lůžko tumoru (Gy)</div>
                                <el-input-number
                                  v-model="medication_rad_dav_tum"
                                  :min="0"
                                  :max="100"
                                  :readonly="modal_medication_ro"
                                  :precision="2"
                                  >
                                </el-input-number>
                              </el-col>
                               <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Metastázy (Gy)</div>
                                <el-input-number
                                  v-model="medication_rad_dav_met"
                                  :min="0"
                                  :max="100"
                                  :readonly="modal_medication_ro"
                                  :precision="2"
                                  >
                                 </el-input-number>
                              </el-col>
                            </el-row>
                          </el-col>
                          <el-col :span="12">
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_dark_blue title-2">Komplikace</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_rad_kom" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_rad_kom" :label="false" @change="vymaz_medication_rad_kom" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Druh</div>
                                <el-form-item class="">
                                  <el-cascader
                                    :disabled="!medication_rad_kom || modal_medication_ro"
                                    v-model="medication_rad_kom_dr"
                                    :options="l_med_cis_kompl_dr"
                                    placeholder="Vyber variantu"
                                    clearable
                                    show-all-levels
                                    :props="{multiple: true}"
                                    >
                                  </el-cascader>
                                </el-form-item>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Časový odstup</div>
                                <el-select
                                  v-model="medication_rad_kom_od"
                                  default-first-option
                                  filterable
                                  clearable
                                  placeholder="Vyber variantu"
                                  :disabled="modal_medication_ro"
                                  >
                                  <el-option
                                    v-for="item of med_rad_kom_od_v"
                                    :key="item"
                                    :label="item"
                                    :value="item">
                                  </el-option>
                                </el-select>
                              </el-col>
                             <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Datum komplikace</div>
                                <el-date-picker
                                  v-model="medication_rad_kom_dat"
                                  type="date"
                                  format="dd. MM. yyyy"
                                  value-format="yyyy-MM-dd"
                                  :picker-options="pickerOptions"
                                  placeholder="Vyber den"
                                  width="100%"
                                  :readonly="modal_medication_ro"
                                  clearable
                                  >
                                </el-date-picker>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Počet dní od zahájení radioterapie</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                                <div class="sum" style="min-height: 28px"><b>{{ medication_rad_od }} </b></div>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <el-row>
                        <el-col :span="24">
                          <div class="card-modal middle_blue">
                            <h3 class="modal_dark_blue title-1">Radiační nekróza</h3>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio v-model="medication_rad_nekr" :label="true" :disabled="modal_medication_ro">ANO</el-radio>
                                  <el-radio v-model="medication_rad_nekr" :label="false" @change="vymaz_medication_rad_nekr" :disabled="modal_medication_ro">NE</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row class="bor">
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <div class="modal_label dark_blue">Klinicky významná</div>
                              </el-col>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item>
                                  <el-radio :disabled="!medication_rad_nekr || modal_medication_ro" v-model="medication_rad_nekr_kl" :label="true">ANO</el-radio>
                                  <el-radio :disabled="!medication_rad_nekr || modal_medication_ro" v-model="medication_rad_nekr_kl" :label="false">NE</el-radio>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                        <el-col :span="24">
                          <div class="card-modal middle_blue">
                            <h3 class="modal_dark_blue title-1">Poznámka</h3>
                            <el-row>
                              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-form-item class="">
                                  <el-input
                                    type="textarea"
                                    :rows="10"
                                    v-model="medication_poznamka"
                                    placeholder="Popis"
                                    :readonly="modal_medication_ro"
                                    >
                                  </el-input>
                                </el-form-item>
                              </el-col>
                            </el-row>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
                  <el-col>
                    <div><span class="modal_label dark_green">*</span> <i>povinná položka</i></div>
                  </el-col>
              </el-row>
              <el-row>
                <el-col :span="24" class="modal_1b_pom">
                  <div class="card-modal green">
                    <h3 class="modal_dark_blue title-1">Stav onemocnění na konci terapie (pro danou linii léčby)</h3>
                    <el-row :gutter="10">
                      <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                        <el-form-item>
                          <el-radio-group v-model="medication_stav_kon" :disabled="modal_medication_ro">
                            <el-radio :label="1" @click.native="click_medication_stav_kon">CR</el-radio>
                            <el-radio :label="2" @click.native="click_medication_stav_kon">PR</el-radio>
                            <el-radio :label="3" @click.native="click_medication_stav_kon">SD</el-radio>
                            <el-radio :label="4" @click.native="click_medication_stav_kon">PD</el-radio>
                          </el-radio-group>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <!-- <el-col :span="5">
              <el-row>
                <el-col>
                  <el-row>
                    <el-col :span="24" class="modal_1c_pom" style="min-height: 180px;">
                      <span class="modal_title light_blue">Vazby</span>
                    </el-col>
                    <el-col style="min-height: 5px; background-color: #789978;">
                    </el-col>
                    <el-col :span="24">
                      <el-tabs type="card" @tab-click="click_vazby_tab" class="red">
                        <el-tab-pane label="Diagnóza/událost" name="vysetreni">
                          <sexaminations v-if="patient.id_patient > 0"></sexaminations>
                        </el-tab-pane>
                        <el-tab-pane label="Operace" name="operace">
                          <soperations v-if="patient.id_patient > 0"></soperations>
                        </el-tab-pane>
                        <el-tab-pane label="Kontroly" name="kontroly">
                          <scheckups v-if="patient.id_patient > 0"></scheckups>
                        </el-tab-pane>
                      </el-tabs>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col> -->
          </el-card>
        </el-row>

        <el-row>
          <el-col class="text-center mt-3">
            <el-button v-if="!modal_medication_ro && medication.id_medication < 1" class="btn-green-big" @click.native="medication_new_save"><i class="el-icon-finished"></i> ULOŽIT </el-button>
            <el-button v-if="!modal_medication_ro && medication.id_medication > 0" type="info" @click.native="medication_edit_save"><i class="el-icon-finished"></i> ULOŽIT ZMĚNY </el-button>
            <el-button class="btn-blue" link @click.native="modal_medication_close(false)"><i class="el-icon-close"></i> ZAVŘÍT</el-button>
          </el-col>
        </el-row>

      </el-form>
    </el-dialog>

  </div>

</template>


<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import MyContent from './Content.vue'

  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
  import axios from 'axios';
  import VueNotify from 'vue-notifyjs'

  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { required, email, confirmed, min } from 'vee-validate/dist/rules';

  import Examinations from 'src/components/Views/Examinations.vue';
  import SExaminations from 'src/components/Views/SExaminations.vue';
  import Operations from 'src/components/Views/Operations.vue';
  import SOperations from 'src/components/Views/SOperations.vue';
  import Checkups from 'src/components/Views/Checkups.vue';
  import SCheckups from 'src/components/Views/SCheckups.vue';
  import Medications from 'src/components/Views/Medications.vue';


  extend('required', {
      ...required,
      message: 'This field is required!'
  });

  extend('email', {
      ...email,
      message: 'Invalid e-mail pattern.'
  });

  extend('min', {
      ...min,
      message: 'At least 6 chars is required.'
   });

  extend('confirmed', {
      ...confirmed,
      message: 'Passwords are different.'
  });

  export default {
    data(){
        return {

          mcs_total: 0,

          radio: '1',

          checked: true,

          lek_nazev: "",


          pickerOptions: {
            firstDayOfWeek: 1,
            shortcuts: [{
              text: 'Dnes',
              onClick(picker) {
                picker.$emit('pick', new Date());
              }
            }, {
              text: 'Včera',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', date);
              }
            }, {
              text: 'Minulý týden',
              onClick(picker) {
                const date = new Date();
                date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', date);
              }
            }]
          },

          value: [],


          // rules_medication: {
          //   nazev_protokol: [
          //     { required: true, message: 'Název protokolu je vyžadován', trigger: 'change' },
          //   ],
            // pat_surname: [
            //   { required: true, message: 'Příjmení je vyžadováno', trigger: 'change' },
            // ],
            // pat_birth_date: [
            //   { required: true, message: 'Datum narození je vyžadováno', trigger: 'change' },
            // ],
            // pat_gender: [
            //   { required: true, message: 'Pohlaví je vyžadováno', trigger: 'change' },
            // ],
            // pat_insu_num: [
            //   { required: true, pattern: /^[0-9][0-9]((0[1-9])|(1[0-2])|(5[1-9])|(6[0-2]))((0[1-9])|(1[0-9])|(2[0-9])|(3[0-1])|(5[1-9])|(6[0-9])|(7[0-9])|(8[0-1]))[0-9]*$/, message: 'Číslo pojištěnce je vyžadováno', trigger: 'change' },
            // ],
            // pat_email: [
            //   { type: 'email', message: 'E-mail má chybný formát.', trigger: 'change' },
            // ],


          // },

          rules_examination: {
            started: [
              { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
            ],

          },

          rules_operation: {
            op_dat_oper: [
              { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
            ],

          },

          rules_checkup: {
            id_dept: [
              { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
            ],
            doctor_id_user: [
              { required: true, message: 'Tato položka je vyžadována.', trigger: 'blur' },
            ]
          },


        }
      },



    components: {
      TopNavbar,
      ContentFooter,
      MyContent,
      ValidationProvider,
      ValidationObserver,
      Examinations,
      [SExaminations.name]: SExaminations,
      Operations,
      [SOperations.name]: SOperations,
      Checkups,
      [SCheckups.name]: SCheckups,
      Medications,
    },


    computed: {
      ...mapState({
        modal_login: state => state.modal_login,
        modal_reg: state => state.modal_reg,
        modal_forgot: state => state.modal_forgot,
        modal_info: state => state.modal_info,
        modal_info_text: state => state.modal_info_text,
        modal_checkup_ro: state => state.modal_checkup_ro,
        modal_examination_ro: state => state.modal_examination_ro,
        modal_operation_ro: state => state.modal_operation_ro,
        modal_medication_ro: state => state.modal_medication_ro,

        token: state => state.token,
        loginuser: state => state.loginuser,
        users: state => state.users,



        patient: state => state.patient,
        patient_panel_a1: state => state.patient_panel_a1,
        patient_panel_a2: state => state.patient_panel_a2,
        patient_panel_b: state => state.patient_panel_b,
        operation: state => state.operation,
        examination: state => state.examination,
        checkup: state => state.checkup,
        checkups: state => state.checkups,
        medication: state => state.medication,
        medicine: state => state.medicine,
        l_check_cis_dept: state => state.l_check_cis_dept,

        examination_checkups: state => state.examination_checkups,

        neurol_deficit_pareza: state => state.neurol_deficit_pareza,
        neurol_deficit_nejtezsi: state => state.neurol_deficit_nejtezsi,
        neurol_deficit_faticka_porucha: state => state.neurol_deficit_faticka_porucha,
        neurol_deficit_hlavovy_nerv: state => state.neurol_deficit_hlavovy_nerv,
        neurol_deficit_senzitivni_deficit: state => state.neurol_deficit_senzitivni_deficit,
        neurol_deficit_ataxie: state => state.neurol_deficit_ataxie,
        neurol_deficit_jiny_pos: state => state.neurol_jiny_pos,
        neurol_deficit_jiny_neg: state => state.neurol_jiny_neg,
        nth_gcs: state => state.nth_gcs,
        lansky_skore: state => state.lansky_skore,
        ecog_skore: state => state.ecog_skore,
        pn_neuro_str_pos: state => state.pn_neuro_str_pos,
        ob_nad_vycet: state => state.ob_nad_vycet,


        op_resekce: state => state.op_resekce,
        op_roz_resekce: state => state.op_roz_resekce,
        op_res_komplikaci: state => state.op_res_komplikaci,
        op_endoskop: state => state.op_endoskop,
        poo_mrs: state => state.poo_mrs,
        poo_pro_hl_nerv: state => state.poo_pro_hl_nerv,

        med_cis_protokol: state => state.med_cis_protokol,
        l_med_cis_chem_int_cyt: state => state.l_med_cis_chem_int_cyt,
        l_med_cis_chem_int_inthe_inver_cyt: state => state.l_med_cis_chem_int_inthe_inver_cyt,
        l_med_cis_udr_chem_inthe_inver_cyt: state => state.l_med_cis_udr_chem_inthe_inver_cyt,
        med_rad_roz_v: state => state.med_rad_roz_v,
        med_rad_kom_od_v: state => state.med_rad_kom_od_v,
        med_rad_typ_v: state => state.med_rad_typ_v,

        l_depts: state => state.l_depts,

        l_exam_diagnozy: state => state.l_exam_diagnozy,
        l_diags: state => state.l_diags,
        l_exam_cis_sk_nadoru: state => state.l_exam_cis_sk_nadoru,
        l_exam_cis_pn_lok_topo_prim: state => state.l_exam_cis_pn_lok_topo_prim,
        l_op_cis_res_kompl: state => state.l_op_cis_res_kompl,
        l_med_cis_kompl_dr: state => state.l_med_cis_kompl_dr,
        l_med_cis_bio_ter_lek: state => state.l_med_cis_bio_ter_lek,

      }),

      ...mapGetters({
        g_med_cis_protokol: 'g_med_cis_protokol',
        g_med_chem_int_inthe_inver_cyt: 'g_med_chem_int_inthe_inver_cyt',
        g_patient_insurance_company: 'g_patient_insurance_company',
        g_l_doctors: 'g_l_doctors',

      }),

      modal_examination: {
        get() { return this.$store.state.modal_examination; },
        set(value) { this.$store.commit('m_modal_examination', value); }
      },

      modal_operation: {
        get() { return this.$store.state.modal_operation; },
        set(value) { this.$store.commit('m_modal_operation', value); }
      },

      modal_medication: {
        get() { return this.$store.state.modal_medication; },
        set(value) { this.$store.commit('m_modal_medication', value); }
      },

      modal_checkup: {
        get() { return this.$store.state.modal_checkup; },
        set(value) { this.$store.commit('m_modal_checkup', value); }
      },

      op_dat_oper: {
        get () { return this.operation.op_dat_oper; },
        set (value) { let mykey = "op_dat_oper"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_biop_ot: {
        get () { return this.operation.op_biop_ot; },
        set (value) { let mykey = "op_biop_ot"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_biop_ster: {
        get () { return this.operation.op_biop_ster; },
        set (value) { let mykey = "op_biop_ster"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_biop_free: {
        get () { return this.operation.op_biop_free; },
        set (value) { let mykey = "op_biop_free"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_biop_endo: {
        get () { return this.operation.op_biop_endo; },
        set (value) { let mykey = "op_biop_endo"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_res: {
        get () { return this.operation.op_res; },
        set (value) { let mykey = "op_res"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_roz_res: {
        get () { return this.operation.op_roz_res; },
        set (value) { let mykey = "op_roz_res"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_pris: {
        get () { return this.operation.op_pris; },
        set (value) { let mykey = "op_pris"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_elektro: {
        get () { return this.operation.op_elektro; },
        set (value) { let mykey = "op_elektro"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_mcs_man_cev: {
        get () { return this.operation.op_mcs_man_cev; },
        set (value) { let mykey = "op_mcs_man_cev"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_mcs_man_hlav: {
        get () { return this.operation.op_mcs_man_hlav; },
        set (value) { let mykey = "op_mcs_man_hlav"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_mcs_zad_jam: {
        get () { return this.operation.op_mcs_zad_jam; },
        set (value) { let mykey = "op_mcs_zad_jam"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_mcs_vet: {
        get () { return this.operation.op_mcs_vet; },
        set (value) { let mykey = "op_mcs_vet"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_mcs_el: {
        get () { return this.operation.op_mcs_el; },
        set (value) { let mykey = "op_mcs_el"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_hyd_shu: {
        get () { return this.operation.op_hyd_shu; },
        set (value) { let mykey = "op_hyd_shu"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_hyd_ev: {
        get () { return this.operation.op_hyd_ev; },
        set (value) { let mykey = "op_hyd_ev"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_hyd_kom: {
        get () { return this.operation.op_hyd_kom; },
        set (value) { let mykey = "op_hyd_kom"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_hyd_rev: {
        get () { return this.operation.op_hyd_rev; },
        set (value) { let mykey = "op_hyd_rev"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_hyd_jiny: {
        get () { return this.operation.op_hyd_jiny; },
        set (value) { let mykey = "op_hyd_jiny"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_hyd_jiny_text: {
        get () { return this.operation.op_hyd_jiny_text; },
        set (value) { let mykey = "op_hyd_jiny_text"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_res_kompl: {
        get () { return this.operation.op_res_kompl; },
        set (value) { let mykey = "op_res_kompl"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_res_kom_jiny_text: {
        get () { return this.operation.op_res_kom_jiny_text; },
        set (value) { let mykey = "op_res_kom_jiny_text"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_jiny_text: {
        get () { return this.operation.op_jiny_text; },
        set (value) { let mykey = "op_jiny_text"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_endo: {
        get () { return this.operation.op_endo; },
        set (value) { let mykey = "op_endo"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_rych_bio: {
        get () { return this.operation.op_rych_bio; },
        set (value) { let mykey = "op_rych_bio"; this.m_operation_by_key( { mykey, value } ); }
      },

      op_pred_dg: {
        get () { return this.operation.op_pred_dg; },
        set (value) { let mykey = "op_pred_dg"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_st: {
        get () { return this.operation.poo_st; },
        set (value) { let mykey = "poo_st"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_par: {
        get () { return this.operation.poo_pro_par; },
        set (value) { let mykey = "poo_pro_par"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_lhk: {
        get () { return this.operation.poo_pro_lhk; },
        set (value) { let mykey = "poo_pro_lhk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_ldk: {
        get () { return this.operation.poo_pro_ldk; },
        set (value) { let mykey = "poo_pro_ldk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_phk: {
        get () { return this.operation.poo_pro_phk; },
        set (value) { let mykey = "poo_pro_phk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_pdk: {
        get () { return this.operation.poo_pro_pdk; },
        set (value) { let mykey = "poo_pro_pdk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_nej_def_s: {
        get () { return this.operation.poo_nej_def_s; },
        set (value) { let mykey = "poo_nej_def_s"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_fa: {
        get () { return this.operation.poo_pro_fa; },
        set (value) { let mykey = "poo_pro_fa"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_fa_ex: {
        get () { return this.operation.poo_pro_fa_ex; },
        set (value) { let mykey = "poo_pro_fa_ex"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_fa_per: {
        get () { return this.operation.poo_pro_fa_per; },
        set (value) { let mykey = "poo_pro_fa_per"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_fa_kom: {
        get () { return this.operation.poo_pro_fa_kom; },
        set (value) { let mykey = "poo_pro_fa_kom"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_hl_ner: {
        get () { return this.operation.poo_pro_hl_ner; },
        set (value) { let mykey = "poo_pro_hl_ner"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_hl_ner_s: {
        get () { return this.operation.poo_pro_hl_ner_s; },
        set (value) { let mykey = "poo_pro_hl_ner_s"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_sen: {
        get () { return this.operation.poo_pro_sen; },
        set (value) { let mykey = "poo_pro_sen"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_sen_lhk: {
        get () { return this.operation.poo_pro_sen_lhk; },
        set (value) { let mykey = "poo_pro_sen_lhk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_sen_ldk: {
        get () { return this.operation.poo_pro_sen_ldk; },
        set (value) { let mykey = "poo_pro_sen_ldk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_sen_phk: {
        get () { return this.operation.poo_pro_sen_phk; },
        set (value) { let mykey = "poo_pro_sen_phk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_sen_pdk: {
        get () { return this.operation.poo_pro_sen_pdk; },
        set (value) { let mykey = "poo_pro_sen_pdk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_at: {
        get () { return this.operation.poo_pro_at; },
        set (value) { let mykey = "poo_pro_at"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_at_lhk: {
        get () { return this.operation.poo_pro_at_lhk; },
        set (value) { let mykey = "poo_pro_at_lhk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_at_ldk: {
        get () { return this.operation.poo_pro_at_ldk; },
        set (value) { let mykey = "poo_pro_at_ldk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_at_phk: {
        get () { return this.operation.poo_pro_at_phk; },
        set (value) { let mykey = "poo_pro_at_phk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_at_pdk: {
        get () { return this.operation.poo_pro_at_pdk; },
        set (value) { let mykey = "poo_pro_at_pdk"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_jiny_text: {
        get () { return this.operation.poo_jiny_text; },
        set (value) { let mykey = "poo_jiny_text"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_ved: {
        get () { return this.operation.poo_pro_ved; },
        set (value) { let mykey = "poo_pro_ved"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_pro_ved_s: {
        get () { return this.operation.poo_pro_ved_s; },
        set (value) { let mykey = "poo_pro_ved_s"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_mor: {
        get () { return this.operation.poo_mor; },
        set (value) { let mykey = "poo_mor"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_moz_mu: {
        get () { return this.operation.poo_moz_mu; },
        set (value) { let mykey = "poo_moz_mu"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_delka: {
        get () { return this.operation.poo_delka; },
        set (value) { let mykey = "poo_delka"; this.m_operation_by_key( { mykey, value } ); }
      },

      poo_rez_pos: {
        get () { return this.operation.poo_rez_pos; },
        set (value) { let mykey = "poo_rez_pos"; this.m_operation_by_key( { mykey, value } ); }
      },

      examination_status: {
        get () { return this.examination.status; },
        set (value) { let mykey = "status"; this.m_examination_by_key( { mykey, value } ); }
      },

      examination_started: {
        get () { return this.examination.started; },
        set (value) { let mykey = "started"; this.m_examination_by_key( { mykey, value } ); }
      },

      examination_finished: {
        get () { return this.examination.finished; },
        set (value) { let mykey = "finished"; this.m_examination_by_key( { mykey, value } ); }
      },

      examination_description: {
        get () { return this.examination.description; },
        set (value) { let mykey = "description"; this.m_examination_by_key( { mykey, value } ); }
      },

      examination_public_note: {
        get () { return this.examination.public_note; },
        set (value) { let mykey = "public_note"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit: {
        get () { return this.examination.neurol_deficit; },
        set (value) { let mykey = "neurol_deficit"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_pareza_pos: {
        get () { return this.examination.neurol_deficit_pareza_pos; },
        set (value) { let mykey = "neurol_deficit_pareza_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_pareza_pos_an: {
        get () { return this.examination.neurol_deficit_pareza_pos_an; },
        set (value) { let mykey = "neurol_deficit_pareza_pos_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_nejtezsi_pos: {
        get () { return this.examination.neurol_deficit_nejtezsi_pos; },
        set (value) { let mykey = "neurol_deficit_nejtezsi_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_faticka_porucha_pos: {
        get () { return this.examination.neurol_deficit_faticka_porucha_pos; },
        set (value) { let mykey = "neurol_deficit_faticka_porucha_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_faticka_porucha_pos_an: {
        get () { return this.examination.neurol_deficit_faticka_porucha_pos_an; },
        set (value) { let mykey = "neurol_deficit_faticka_porucha_pos_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_hlavovy_nerv_pos: {
        get () { return this.examination.neurol_deficit_hlavovy_nerv_pos; },
        set (value) { let mykey = "neurol_deficit_hlavovy_nerv_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_hlavovy_nerv_pos_an: {
        get () { return this.examination.neurol_deficit_hlavovy_nerv_pos_an; },
        set (value) { let mykey = "neurol_deficit_hlavovy_nerv_pos_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_senzitivni_deficit_pos: {
        get () { return this.examination.neurol_deficit_senzitivni_deficit_pos; },
        set (value) { let mykey = "neurol_deficit_senzitivni_deficit_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_senzitivni_deficit_pos_an: {
        get () { return this.examination.neurol_deficit_senzitivni_deficit_pos_an; },
        set (value) { let mykey = "neurol_deficit_senzitivni_deficit_pos_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_ataxie_pos: {
        get () { return this.examination.neurol_deficit_ataxie_pos; },
        set (value) { let mykey = "neurol_deficit_ataxie_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_ataxie_pos_an: {
        get () { return this.examination.neurol_deficit_ataxie_pos_an; },
        set (value) { let mykey = "neurol_deficit_ataxie_pos_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_jiny_pos: {
        get () { return this.examination.neurol_deficit_jiny_pos; },
        set (value) { let mykey = "neurol_deficit_jiny_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_jiny_pos_text: {
        get () { return this.examination.neurol_deficit_jiny_pos_text; },
        set (value) { let mykey = "neurol_deficit_jiny_pos_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_pareza_neg: {
        get () { return this.examination.neurol_deficit_pareza_neg; },
        set (value) { let mykey = "neurol_deficit_pareza_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_pareza_neg_an: {
        get () { return this.examination.neurol_deficit_pareza_neg_an; },
        set (value) { let mykey = "neurol_deficit_pareza_neg_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_nejtezsi_neg: {
        get () { return this.examination.neurol_deficit_nejtezsi_neg; },
        set (value) { let mykey = "neurol_deficit_nejtezsi_neg"; this.m_examination_by_key( { mykey, value } ); }
      },


      neurol_deficit_faticka_porucha_neg: {
        get () { return this.examination.neurol_deficit_faticka_porucha_pos; },
        set (value) { let mykey = "neurol_deficit_faticka_porucha_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_faticka_porucha_neg_an: {
        get () { return this.examination.neurol_deficit_faticka_porucha_neg_an; },
        set (value) { let mykey = "neurol_deficit_faticka_porucha_neg_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_hlavovy_nerv_neg: {
        get () { return this.examination.neurol_deficit_hlavovy_nerv_neg; },
        set (value) { let mykey = "neurol_deficit_hlavovy_nerv_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_hlavovy_nerv_neg_an: {
        get () { return this.examination.neurol_deficit_hlavovy_nerv_neg_an; },
        set (value) { let mykey = "neurol_deficit_hlavovy_nerv_neg_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_senzitivni_deficit_neg: {
        get () { return this.examination.neurol_deficit_senzitivni_deficit_neg; },
        set (value) { let mykey = "neurol_deficit_senzitivni_deficit_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_senzitivni_deficit_neg_an: {
        get () { return this.examination.neurol_deficit_senzitivni_deficit_neg_an; },
        set (value) { let mykey = "neurol_deficit_senzitivni_deficit_neg_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_ataxie_neg: {
        get () { return this.examination.neurol_deficit_ataxie_neg; },
        set (value) { let mykey = "neurol_deficit_ataxie_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_ataxie_neg_an: {
        get () { return this.examination.neurol_deficit_ataxie_neg_an; },
        set (value) { let mykey = "neurol_deficit_ataxie_neg_an"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_jiny_neg: {
        get () { return this.examination.neurol_deficit_jiny_neg; },
        set (value) { let mykey = "neurol_deficit_jiny_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      neurol_deficit_jiny_neg_text: {
        get () { return this.examination.neurol_deficit_jiny_neg_text; },
        set (value) { let mykey = "neurol_deficit_jiny_neg_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth: {
        get () { return this.examination.nth; },
        set (value) { let mykey = "nth"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth_cefalea_pos: {
        get () { return this.examination.nth_cefalea_pos; },
        set (value) { let mykey = "nth_cefalea_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth_zvraceni_pos: {
        get () { return this.examination.nth_zvraceni_pos; },
        set (value) { let mykey = "nth_zvraceni_pos"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth_mestnani_pos: {
        get () { return this.examination.nth_mestnani_pos; },
        set (value) { let mykey = "nth_mestnani_pos"; this.m_examination_by_key( { mykey, value } ); }
      },


      nth_cefalea_neg: {
        get () { return this.examination.nth_cefalea_neg; },
        set (value) { let mykey = "nth_cefalea_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth_zvraceni_neg: {
        get () { return this.examination.nth_zvraceni_neg; },
        set (value) { let mykey = "nth_zvraceni_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth_mestnani_neg: {
        get () { return this.examination.nth_mestnani_neg; },
        set (value) { let mykey = "nth_mestnani_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      nth_gcs_neg: {
        get () { return this.examination.nth_gcs_neg; },
        set (value) { let mykey = "nth_gcs_neg"; this.m_examination_by_key( { mykey, value } ); }
      },

      lansky_skore_p: {
        get () { return this.examination.lansky_skore_p; },
        set (value) { let mykey = "lansky_skore_p"; this.m_examination_by_key( { mykey, value } ); }
      },

      ecog_skore_p: {
        get () { return this.examination.ecog_skore_p; },
        set (value) { let mykey = "ecog_skore_p"; this.m_examination_by_key( { mykey, value } ); }
      },

      gcs: {
        get () { return this.examination.gcs; },
        set (value) { let mykey = "gcs"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_lok_str: {
        get () { return this.examination.pn_lok_str; },
        set (value) { let mykey = "pn_lok_str"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_lok_topo_prim: {
        get () { return this.examination.pn_lok_topo_prim; },
        set (value) { let mykey = "pn_lok_topo_prim"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_lok_topo_prim_jiny_text: {
        get () { return this.examination.pn_lok_topo_prim_jiny_text; },
        set (value) { let mykey = "pn_lok_topo_prim_jiny_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_lok_topo_sir: {
        get () { return this.examination.pn_lok_topo_sir; },
        set (value) { let mykey = "pn_lok_topo_sir"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_lok_topo_sir_jiny_text: {
        get () { return this.examination.pn_lok_topo_sir_jiny_text; },
        set (value) { let mykey = "pn_lok_topo_sir_jiny_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_el_zona: {
        get () { return this.examination.pn_el_zona; },
        set (value) { let mykey = "pn_el_zona"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_vel_ap: {
        get () { return this.examination.pn_vel_ap; },
        set (value) { let mykey = "pn_vel_ap"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_vel_lat: {
        get () { return this.examination.pn_vel_lat; },
        set (value) { let mykey = "pn_vel_lat"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_vel_kra: {
        get () { return this.examination.pn_vel_kra; },
        set (value) { let mykey = "pn_vel_kra"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_vol: {
        get () { return this.examination.pn_vol; },
        set (value) { let mykey = "pn_vol"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_neuro_str_v: {
        get () { return this.examination.pn_neuro_str_v; },
        set (value) { let mykey = "pn_neuro_str_v"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_neuro_str_m: {
        get () { return this.examination.pn_neuro_str_m; },
        set (value) { let mykey = "pn_neuro_str_m"; this.m_examination_by_key( { mykey, value } ); }
      },

      pn_neuro_str_jiny_text: {
        get () { return this.examination.pn_neuro_str_jiny_text; },
        set (value) { let mykey = "pn_neuro_str_jiny_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      dn_prog_rez_text: {
        get () { return this.examination.dn_prog_rez_text; },
        set (value) { let mykey = "dn_prog_rez_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      dn_lok_rec_text: {
        get () { return this.examination.dn_lok_rec_text; },
        set (value) { let mykey = "dn_lok_rec_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      dn_dis_met_text: {
        get () { return this.examination.dn_dis_met_text; },
        set (value) { let mykey = "dn_dis_met_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      dn_dupl_text: {
        get () { return this.examination.dn_dupl_text; },
        set (value) { let mykey = "dn_dupl_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_prim: {
        get () { return this.examination.on_prim; },
        set (value) { let mykey = "on_prim"; this.m_examination_by_key( { mykey, value } ); }
      },

      ob_nad: {
        get () { return this.examination.ob_nad; },
        set (value) { let mykey = "ob_nad"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_d_uk_pro_prog_gr: {
        get () { return this.examination.on_d_uk_pro_prog_gr; },
        set (value) { let mykey = "on_d_uk_pro_prog_gr"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_d_uk_pro_prog_sym: {
        get () { return this.examination.on_d_uk_pro_prog_sym; },
        set (value) { let mykey = "on_d_uk_pro_prog_sym"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_d_uk_pro_pra: {
        get () { return this.examination.on_d_uk_pro_pra; },
        set (value) { let mykey = "on_d_uk_pro_pra"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_d_uk_pro_jiny: {
        get () { return this.examination.on_d_uk_pro_jiny; },
        set (value) { let mykey = "on_d_uk_pro_jiny"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_d_uk_pro_jiny_text: {
        get () { return this.examination.on_d_uk_pro_jiny_text; },
        set (value) { let mykey = "on_d_uk_pro_jiny_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      on_d_uk: {
        get () { return this.examination.on_d_uk; },
        set (value) { let mykey = "on_d_uk"; this.m_examination_by_key( { mykey, value } ); }
      },

      id_diagnoza: {
        get () { return this.examination.id_diagnoza; },
        set (value) { let mykey = "id_diagnoza"; this.m_examination_by_key( { mykey, value } ); }
      },

      id_nador: {
        get () { return this.examination.id_nador; },
        set (value) { let mykey = "id_nador"; this.m_examination_by_key( { mykey, value } ); }
      },

      diagnoza_dat: {
        get () { return this.examination.diagnoza_dat; },
        set (value) { let mykey = "diagnoza_dat"; this.m_examination_by_key( { mykey, value } ); }
      },


      vstup_st: {
        get () { return this.examination.vstup_st; },
        set (value) { let mykey = "vstup_st"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_met: {
        get () { return this.examination.vstup_st_met; },
        set (value) { let mykey = "vstup_st_met"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_met_rad: {
        get () { return this.examination.vstup_st_met_rad; },
        set (value) { let mykey = "vstup_st_met_rad"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_met_intra_text: {
        get () { return this.examination.vstup_st_met_intra_text; },
        set (value) { let mykey = "vstup_st_met_intra_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_met_kan_text: {
        get () { return this.examination.vstup_st_met_kan_text; },
        set (value) { let mykey = "vstup_st_met_kan_text"; this.m_examination_by_key( { mykey, value } ); }
      },


      vstup_st_met_intr_kan_text: {
        get () { return this.examination.vstup_st_met_intr_kan_text; },
        set (value) { let mykey = "vstup_st_met_intr_kan_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_cyt: {
        get () { return this.examination.vstup_st_cyt; },
        set (value) { let mykey = "vstup_st_cyt"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_cyt_pn: {
        get () { return this.examination.vstup_st_cyt_pn; },
        set (value) { let mykey = "vstup_st_cyt_pn"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_cyt_p_text: {
        get () { return this.examination.vstup_st_cyt_p_text; },
        set (value) { let mykey = "vstup_st_cyt_p_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      vstup_st_cha: {
        get () { return this.examination.vstup_st_cha; },
        set (value) { let mykey = "vstup_st_cha"; this.m_examination_by_key( { mykey, value } ); }
      },


      mol_ge_snv: {
        get () { return this.examination.mol_ge_snv; },
        set (value) { let mykey = "mol_ge_snv"; this.m_examination_by_key( { mykey, value } ); }
      },

      mol_ge_snv_text: {
        get () { return this.examination.mol_ge_snv_text; },
        set (value) { let mykey = "mol_ge_snv_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      mol_ge_fuze: {
        get () { return this.examination.mol_ge_fuze; },
        set (value) { let mykey = "mol_ge_fuze"; this.m_examination_by_key( { mykey, value } ); }
      },

      mol_ge_fuze_text: {
        get () { return this.examination.mol_ge_fuze_text; },
        set (value) { let mykey = "mol_ge_fuze_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      mol_ge_cnv: {
        get () { return this.examination.mol_ge_cnv; },
        set (value) { let mykey = "mol_ge_cnv"; this.m_examination_by_key( { mykey, value } ); }
      },

      mol_ge_cnv_text: {
        get () { return this.examination.mol_ge_cnv_text; },
        set (value) { let mykey = "mol_ge_cnv_text"; this.m_examination_by_key( { mykey, value } ); }
      },

      mol_ge_methyl_text: {
        get () { return this.examination.mol_ge_methyl_text; },
        set (value) { let mykey = "mol_ge_methyl_text"; this.m_examination_by_key( { mykey, value } ); }
      },



      checkup_id_checkup: {
        get () { return this.checkup.id_checkup; },
        set (value) { let mykey = "id_checkup"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_id_patient: {
        get () { return this.checkup.id_patient; },
        set (value) { let mykey = "id_patient"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_doctor_id_user: {
        get () { return this.checkup.doctor_id_user; },
        set (value) { let mykey = "doctor_id_user"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_id_dept: {
        get () { return this.checkup.id_dept; },
        set (value) { let mykey = "id_dept"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_id_examination: {
        get () { return this.checkup.id_examination; },
        set (value) { let mykey = "id_examination"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_status: {
        get () { return this.checkup.status; },
        set (value) { let mykey = "status"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_dt_when: {
        get () { return this.checkup.dt_when; },
        set (value) { let mykey = "dt_when"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_privat_note: {
        get () { return this.checkup.privat_note; },
        set (value) { let mykey = "privat_note"; this.m_checkup_item( { mykey, value } ); }
      },

      checkup_public_note: {
        get () { return this.checkup.public_note; },
        set (value) { let mykey = "public_note"; this.m_checkup_item( { mykey, value } ); }
      },

      medication_klin_st: {
        get () { return this.medication.klin_st; },
        set (value) { let mykey = "klin_st"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_cis_st: {
        get () { return this.medication.cis_st; },
        set (value) { let mykey = "cis_st"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_nazev_protokol: {
        get () { return this.medication.nazev_protokol; },
        set (value) { let mykey = "nazev_protokol"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_id_med_cis_protokol: {
        get () { return this.medication.id_med_cis_protokol; },
        set (value) { let mykey = "id_med_cis_protokol"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int: {
        get () { return this.medication.chem_int; },
        set (value) { let mykey = "chem_int"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_z: {
        get () { return this.medication.chem_int_z; },
        set (value) { let mykey = "chem_int_z"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_k: {
        get () { return this.medication.chem_int_k; },
        set (value) { let mykey = "chem_int_k"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_cyt: {
        get () { return this.medication.chem_int_cyt; },
        set (value) { let mykey = "chem_int_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_kom: {
        get () { return this.medication.chem_int_kom; },
        set (value) { let mykey = "chem_int_kom"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_kom_dr: {
        get () { return this.medication.chem_int_kom_dr; },
        set (value) { let mykey = "chem_int_kom_dr"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_re_cyt: {
        get () { return this.medication.chem_int_re_cyt; },
        set (value) { let mykey = "chem_int_re_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_inthe_ter: {
        get () { return this.medication.chem_int_inthe_ter; },
        set (value) { let mykey = "chem_int_inthe_ter"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_inthe_ter_cyt: {
        get () { return this.medication.chem_int_inthe_ter_cyt; },
        set (value) { let mykey = "chem_int_inthe_ter_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_inver_ter: {
        get () { return this.medication.chem_int_inver_ter; },
        set (value) { let mykey = "chem_int_inver_ter"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_chem_int_inver_ter_cyt: {
        get () { return this.medication.chem_int_inver_ter_cyt; },
        set (value) { let mykey = "chem_int_inver_ter_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },


      medication_udr_chem: {
        get () { return this.medication.udr_chem; },
        set (value) { let mykey = "udr_chem"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_z: {
        get () { return this.medication.udr_chem_z; },
        set (value) { let mykey = "udr_chem_z"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_k: {
        get () { return this.medication.udr_chem_k; },
        set (value) { let mykey = "udr_chem_k"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_text: {
        get () { return this.medication.udr_chem_text; },
        set (value) { let mykey = "udr_chem_text"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_kom: {
        get () { return this.medication.udr_chem_kom; },
        set (value) { let mykey = "udr_chem_kom"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_kom_dr: {
        get () { return this.medication.udr_chem_kom_dr; },
        set (value) { let mykey = "udr_chem_kom_dr"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_kom_st: {
        get () { return this.medication.udr_chem_kom_st; },
        set (value) { let mykey = "udr_chem_kom_st"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_re_cyt: {
        get () { return this.medication.udr_chem_re_cyt; },
        set (value) { let mykey = "udr_chem_re_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_inthe_ter: {
        get () { return this.medication.udr_chem_inthe_ter; },
        set (value) { let mykey = "udr_chem_inthe_ter"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_inthe_ter_cyt: {
        get () { return this.medication.udr_chem_inthe_ter_cyt; },
        set (value) { let mykey = "udr_chem_inthe_ter_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_inver_ter: {
        get () { return this.medication.udr_chem_inver_ter; },
        set (value) { let mykey = "udr_chem_inver_ter"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_udr_chem_inver_ter_cyt: {
        get () { return this.medication.udr_chem_inver_ter_cyt; },
        set (value) { let mykey = "udr_chem_inver_ter_cyt"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter: {
        get () { return this.medication.bio_ter; },
        set (value) { let mykey = "bio_ter"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_z: {
        get () { return this.medication.bio_ter_z; },
        set (value) { let mykey = "bio_ter_z"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_k: {
        get () { return this.medication.bio_ter_k; },
        set (value) { let mykey = "bio_ter_k"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_lek: {
        get () { return this.medication.bio_ter_lek; },
        set (value) { let mykey = "bio_ter_lek"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_kom: {
        get () { return this.medication.bio_ter_kom; },
        set (value) { let mykey = "bio_ter_kom"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_kom_dr: {
        get () { return this.medication.bio_ter_kom_dr; },
        set (value) { let mykey = "bio_ter_kom_dr"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_kom_st: {
        get () { return this.medication.bio_ter_kom_st; },
        set (value) { let mykey = "bio_ter_kom_st"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_bio_ter_re: {
        get () { return this.medication.bio_ter_re; },
        set (value) { let mykey = "bio_ter_re"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad: {
        get () { return this.medication.rad; },
        set (value) { let mykey = "rad"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_typ: {
        get () { return this.medication.rad_typ; },
        set (value) { let mykey = "rad_typ"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_z: {
        get () { return this.medication.rad_z; },
        set (value) { let mykey = "rad_z"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_op: {
        get () { return this.medication.rad_op; },
        set (value) { let mykey = "rad_op"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_op_od: {
        get () { return this.medication.rad_op_od; },
        set (value) { let mykey = "rad_op_od"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_k: {
        get () { return this.medication.rad_k; },
        set (value) { let mykey = "rad_k"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_id_operation: {
        get () { return this.medication.id_operation; },
        set (value) { let mykey = "id_operation"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_roz: {
        get () { return this.medication.rad_roz; },
        set (value) { let mykey = "rad_roz"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_dav_kra: {
        get () { return this.medication.rad_dav_kra; },
        set (value) { let mykey = "rad_dav_kra"; this.m_medication_by_key( { mykey, value } ); }
      },

       medication_rad_dav_tum: {
        get () { return this.medication.rad_dav_tum; },
        set (value) { let mykey = "rad_dav_tum"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_dav_met: {
        get () { return this.medication.rad_dav_met; },
        set (value) { let mykey = "rad_dav_met"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_kom: {
        get () { return this.medication.rad_kom; },
        set (value) { let mykey = "rad_kom"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_kom_dr: {
        get () { return this.medication.rad_kom_dr; },
        set (value) { let mykey = "rad_kom_dr"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_kom_st: {
        get () { return this.medication.rad_kom_st; },
        set (value) { let mykey = "rad_kom_st"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_kom_od: {
        get () { return this.medication.rad_kom_od; },
        set (value) { let mykey = "rad_kom_od"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_kom_dat: {
        get () { return this.medication.rad_kom_dat; },
        set (value) { let mykey = "rad_kom_dat"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_od: {
        get () { return this.medication.rad_od; },
        set (value) { let mykey = "rad_od"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_kom_do: {
        get () { return this.medication.rad_kom_do; },
        set (value) { let mykey = "rad_kom_do"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_nekr: {
        get () { return this.medication.rad_nekr; },
        set (value) { let mykey = "rad_nekr"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_rad_nekr_kl: {
        get () { return this.medication.rad_nekr_kl; },
        set (value) { let mykey = "rad_nekr_kl"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_stav_kon: {
        get () { return this.medication.stav_kon; },
        set (value) { let mykey = "stav_kon"; this.m_medication_by_key( { mykey, value } ); }
      },

      medication_poznamka: {
        get () { return this.medication.poznamka; },
        set (value) { let mykey = "poznamka"; this.m_medication_by_key( { mykey, value } ); }
      },

    },


    methods: {
      ...mapMutations({
        m_modal_password_forgot: 'm_modal_password_forgot',
        m_modal_info: 'm_modal_info',
        m_modal_info_text: 'm_modal_info_text',

        m_modal_checkup: 'm_modal_checkup',
        m_modal_checkup_ro: 'm_modal_checkup_ro',
        m_checkup_item: 'm_checkup_item',
        m_checkup_reset: 'm_checkup_reset',

        m_modal_operation: 'm_modal_operation',
        m_modal_operation_ro: 'm_modal_operation_ro',
        m_operation_reset: 'm_operation_reset',
        m_operation_by_key: 'm_operation_by_key',

        m_modal_examination: 'm_modal_examination',
        m_modal_examination_ro: 'm_modal_examination_ro',
        m_examination_reset: 'm_examination_reset',
        m_examination_by_key: 'm_examination_by_key',

        m_modal_medication: 'm_modal_medication',
        m_modal_medication_ro: 'm_modal_medication_ro',
        m_medication_reset: 'm_medication_reset',
        m_medication_by_key: 'm_medication_by_key',

      }),


      ...mapActions({
        a_load_profile: 'a_load_profile',
        a_examination_new: 'a_examination_new',
        a_examination_update: 'a_examination_update',
        a_operation_new: 'a_operation_new',
        a_operation_update: 'a_operation_update',
        a_checkup_new: 'a_checkup_new',
        a_checkup_update: 'a_checkup_update',
        a_medication_new: 'a_medication_new',
        a_medication_update: 'a_medication_update',
        a_med_cis_bio_ter_lek:  'a_med_cis_bio_ter_lek',
        a_med_cis_bio_ter_lek_add:  'a_med_cis_bio_ter_lek_add',
        a_med_cis_protokol_add:  'a_med_cis_protokol_add',
        a_med_cis_chem_int_cyt_add:  'a_med_cis_chem_int_cyt_add',
        a_med_cis_chem_int_inthe_inver_cyt_add:  'a_med_cis_chem_int_inthe_inver_cyt_add',
        a_med_cis_udr_chem_inthe_inver_cyt_add:  'a_med_cis_udr_chem_inthe_inver_cyt_add',

        a_patient: 'a_patient',
        a_patients: 'a_patients',
        a_examinations: 'a_examinations',
        a_examination: 'a_examination',
        a_operations: 'a_operations',
        a_operation: 'a_operation',
        a_checkups: 'a_checkups',
        a_checkup: 'a_checkup',
        a_medications: 'a_medications',
        a_medication: 'a_medication',

      }),


      handleChange(value) {
        console.log(value);
      },


      modal_examination_close(form_name) {
        this.m_modal_examination(false);
        this.$refs[form_name].resetFields();
      },


      closed_modal_examination(form_name) {
        this.m_modal_examination_ro(false);
        this.m_modal_examination(false);
        this.$refs[form_name].resetFields();
      },


      modal_operation_close(form_name) {
        this.m_modal_operation(false);
        this.$refs[form_name].resetFields();
      },


      closed_modal_operation(form_name) {
        this.m_modal_operation_ro(false);
        this.m_modal_operation(false);
        this.$refs[form_name].resetFields();
      },


      modal_checkup_close(form_name) {
        this.m_modal_checkup(false);
        this.$refs[form_name].resetFields();
      },


      closed_modal_checkup(form_name) {
        this.m_modal_checkup_ro(false);
        this.m_modal_checkup(false);
        this.$refs[form_name].resetFields();
      },


      modal_medication_close(form_name) {
        this.m_modal_medication(false);
        this.$refs[form_name].resetFields();
      },


      closed_modal_medication(form_name) {
        this.m_modal_medication_ro(false);
        this.m_modal_medication(false);
        this.$refs[form_name].resetFields();
      },


      examination_new_save(form_name) {
        this.$refs[form_name].validate((valid) => {
          if (valid) {
            this.a_examination_new( this.examination );
            this.m_modal_examination(false);
          } else {
            this.$notify({
              title: 'INFO',
              message: "Vyplňte prosím povinnou položku.",
              type: 'warning',
              position: 'top-left',
            });
          }
        })
      },


      examination_edit_save(form_name) {
        this.$refs[form_name].validate((valid) => {
          if (valid) {
            this.a_examination_update( this.examination );
            this.m_modal_examination(false);
          } else {
            this.$notify({
              title: 'INFO',
              message: "Vyplňte prosím povinnou položku.",
              type: 'warning',
              position: 'top-left',
            });
          }
        })
      },


      click_exam_pn_lok_str(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.examination.pn_lok_str) {
          this.examination.pn_lok_str = null;
        }
      },


      click_exam_vstup_st_met_rad(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.examination.vstup_st_met_rad) {
          this.examination.vstup_st_met_rad = null;
          this.examination.vstup_st_met_intra_text = null;
          this.examination.vstup_st_met_kan_text = null;
          this.examination.vstup_st_met_intr_kan_text = null;
        }
      },


      click_exam_vstup_st_cha(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.examination.vstup_st_cha) {
          this.examination.vstup_st_cha = null;
        }
      },


      click_exam_vstup_st_cyt_pn(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.examination.vstup_st_cyt_pn) {
          this.examination.vstup_st_cyt_pn = null;
          this.examination.vstup_st_cyt_p_text = null;
        }
      },


      click_medication_stav_kon(event) {
        let xxx = event.srcElement._value;
        if (xxx === this.medication.stav_kon) {
          this.medication.stav_kon = null;
        }
      },


     vymaz_vstup_st_met_rad(value) {
        this.examination.vstup_st_met_rad = [];
        this.examination.vstup_st_met_intra_text = "";
        this.examination.vstup_st_met_kan_text = "";
        this.examination.vstup_st_met_intr_kan_text = "";
      },


     vymaz_vstup_st_met_1(value) {
        this.examination.vstup_st_met_kan_text = "";
        this.examination.vstup_st_met_intr_kan_text = "";
      },


     vymaz_vstup_st_met_2(value) {
        this.examination.vstup_st_met_intra_text = "";
        this.examination.vstup_st_met_intr_kan_text = "";
      },


     vymaz_vstup_st_met_3(value) {
        this.examination.vstup_st_met_intra_text = "";
        this.examination.vstup_st_met_kan_text = "";
      },


     vymaz_vstup_st_cyt_p_text(value) {
       this.examination.vstup_st_cyt_p_text = null;
      },


      vymaz_pn_neuro_str_m(value) {
        if (!value.includes("jiný")) {
          this.examination.pn_neuro_str_jiny_text = null;
        }
      },


      vymaz_pn_neuro_str_v(value) {
        this.examination.pn_neuro_str_jiny_text = null;
        this.examination.pn_neuro_str_m = [];
      },


      vymaz_on_d_uk_pro_jiny_text(value) {
        if (value === false) {
          this.examination.on_d_uk_pro_jiny_text = null;
        }
      },


      vymaz_pn_lok_topo_prim(value) {
        if (value !== "jiný") {
          this.examination.pn_lok_topo_prim_jiny_text = null;
        }
      },


      vymaz_pn_lok_topo_sir() {
        if (!this.examination.pn_lok_topo_sir.includes(20)) {
          this.examination.pn_lok_topo_sir_jiny_text = null;
        }
      },


      vymaz_mol_ge_snv_text() {
        this.examination.mol_ge_snv_text = null;
      },


      vymaz_mol_ge_fuze_text() {
        this.examination.mol_ge_fuze_text = null;
      },


      vymaz_mol_ge_cnv_text() {
        this.examination.mol_ge_cnv_text = null;
      },


      operation_new_save(form_name) {
        this.$refs[form_name].validate((valid) => {
          if (valid) {
            this.a_operation_new( this.operation );
            this.m_modal_operation(false);
          } else {
            this.$notify({
              title: 'INFO',
              message: "Vyplňte prosím povinnou položku.",
              type: 'warning',
              position: 'top-left',
            });
          }
        })
      },


      operation_edit_save(form_name) {
        this.$refs[form_name].validate((valid) => {
          if (valid) {
            this.a_operation_update( this.operation );
            this.m_modal_operation(false);
          } else {
            this.$notify({
              title: 'INFO',
              message: "Vyplňte prosím povinnou položku.",
              type: 'warning',
              position: 'top-left',
            });
          }
        })
      },


      vymaz_poo_pro_par(value) {
          this.operation.poo_pro_lhk = null;
          this.operation.poo_pro_ldk = null;
          this.operation.poo_pro_phk = null;
          this.operation.poo_pro_pdk = null;
      },


      vymaz_poo_pro_hl_ner(value) {
          this.operation.poo_pro_hl_ner_s = null;
      },


      vymaz_poo_pro_sen(value) {
          this.operation.poo_pro_sen_lhk = null;
          this.operation.poo_pro_sen_ldk = null;
          this.operation.poo_pro_sen_phk = null;
          this.operation.poo_pro_sen_pdk = null;
      },


      vymaz_poo_pro_fa(value) {
          this.operation.poo_pro_fa_ex = null;
          this.operation.poo_pro_fa_per = null;
          this.operation.poo_pro_fa_kom = null;
      },


      vymaz_poo_pro_ved(value) {
          this.operation.poo_pro_ved_s = null;
      },


      vymaz_poo_pro_at(value) {
          this.operation.poo_pro_at_lhk = null;
          this.operation.poo_pro_at_ldk = null;
          this.operation.poo_pro_at_phk = null;
          this.operation.poo_pro_at_pdk = null;
      },


      vymaz_op_rych_bio(value) {
          this.operation.op_pred_dg = null;
      },


      vymaz_op_hyd_jiny_text(value) {
        if (value === false) {
          this.operation.op_hyd_jiny_text = null;
        }
      },

      vymaz_op_res_kompl() {
        var a = this.operation.op_res_kompl;
        var b = ["Hematom","jiný"];
        a = JSON.stringify(a);
        b = JSON.stringify(b);
        var c = a.indexOf(b);

        if (c === -1) {
          this.operation.op_res_kom_jiny_text = null;
        }
      },


      checkup_new_save(form_name) {
        this.$refs[form_name].validate((valid) => {
          if (valid) {
            this.a_checkup_new( this.checkup );
            this.m_modal_checkup(false);
          } else {
            this.$notify({
              title: 'INFO',
              message: "Vyplňte prosím povinnou položku.",
              type: 'warning',
              position: 'top-left',
            });
          }
        })
      },


      checkup_edit_save(form_name) {
        this.$refs[form_name].validate((valid) => {
          if (valid) {
            this.a_checkup_update( this.checkup );
            this.m_modal_checkup(false);
          } else {
            this.$notify({
              title: 'INFO',
              message: "Vyplňte prosím povinnou položku.",
              type: 'warning',
              position: 'top-left',
            });
          }
        })
      },



      medication_new_save() {
        this.a_medication_new( this.medication );
        this.m_modal_medication(false);

      },


      medication_edit_save() {
        this.a_medication_update( this.medication );
        this.m_modal_medication(false);
      },


      vymaz_medication_chem_int(value) {
          this.medication.chem_int_z = null;
          this.medication.chem_int_k = null;
          this.medication.chem_int_cyt = null;
      },


      vymaz_medication_chem_int_kom(value) {
          this.medication.chem_int_kom_dr = null;
      },


      vymaz_medication_chem_inthe_ter(value) {
          this.medication.chem_int_inthe_ter_cyt = null;
      },


      vymaz_medication_chem_int_inver_ter(value) {
          this.medication.chem_int_inver_ter_cyt = null;
      },


      vymaz_medication_udr_chem_kom(value) {
          this.medication.udr_chem_kom_dr = null;
          this.medication.udr_chem_kom_st = null;
      },


      vymaz_medication_udr_chem_inthe_ter(value) {
          this.medication.udr_chem_inthe_ter_cyt = null;
      },


      vymaz_medication_udr_chem_inver_ter(value) {
          this.medication.udr_chem_inver_ter_cyt = null;
      },


      vymaz_medication_bio_ter(value) {
          this.medication.bio_ter_z = null;
          this.medication.bio_ter_k = null
          this.medication.bio_ter_lek = null
      },


      vymaz_medication_udr_chem(value) {
          this.medication.udr_chem_z = null;
          this.medication.udr_chem_k = null;
          this.medication.udr_chem_text = null;
      },


      vymaz_medication_bio_ter_kom(value) {
          this.medication.bio_ter_kom_dr = null;
          this.medication.bio_ter_kom_st = null;
      },


      vymaz_medication_rad(value) {
          this.medication.rad_typ = null;
      },


      vymaz_medication_rad_kom(value) {
          this.medication.rad_kom_dr = null;
          this.medication.rad_kom_st = null;
          this.medication.rad_kom_od = null;
          this.medication.rad_kom_dat = null;
          this.medication.rad_kom_do = null;
      },


      vymaz_medication_rad_nekr(value) {
          this.medication.rad_nekr_kl = null;
      },


      change_checkup_id_dept(value) {
          this.checkup.doctor_id_user = null;
      },


      click_vazby_tab(tab, event) {
        if (tab.name === "lecba") {
          this.a_medications();
        } else if  (tab.name === "vysetreni") {
          this.a_examinations();
        } else if  (tab.name === "operace") {
          this.a_operations();
        } else if  (tab.name === "kontroly") {
          this.a_checkups();
        }
      },

    }
  }


</script>
<style scoped lang="scss">
.wrapper {
    top: 0 !important;
}
.main-panel > .content {
    min-height: calc(100vh - 10px) !important;
}
.main_background {
  background-image: url('/img/bg_brain_nav_2.jpg');
  width: 100%;
  background-position: center;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 400px;
  height: 500px;
}
.hid-large {
  text-align: center;
  color: rgb(75, 118, 153);
}

.modal_1b_ro {
  padding: 25px;
  background-image: url('/img/pokus_01.png');
  background-repeat: repeat;
}

.header_space {
    border-radius: 4px;
    min-height: 36px;
    background: transparent;
}


</style>
